/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Input type for dynamic zone CallToAction of AdditionalProducts */
  AdditionalProductsCallToActionDynamicZoneInput: { input: any; output: any; }
  /** Input type for dynamic zone ProductCollection of Companies */
  CompaniesProductCollectionDynamicZoneInput: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** Input type for dynamic zone Elements of FormPages */
  FormPagesElementsDynamicZoneInput: { input: any; output: any; }
  /** Input type for dynamic zone Elements of Forms */
  FormsElementsDynamicZoneInput: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Long` scalar type represents 52-bit integers */
  Long: { input: any; output: any; }
  /** Input type for dynamic zone Elements of Modals */
  ModalsElementsDynamicZoneInput: { input: any; output: any; }
  /** Input type for dynamic zone Content of Modules */
  ModulesContentDynamicZoneInput: { input: any; output: any; }
  /** Input type for dynamic zone CallToAction of StoryPages */
  StoryPagesCallToActionDynamicZoneInput: { input: any; output: any; }
  /** A time string with format: HH:mm:ss.SSS */
  Time: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Accessor = {
  extraField?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
};

export type AdditionalProductInput = {
  CallToAction?: InputMaybe<Array<Scalars['AdditionalProductsCallToActionDynamicZoneInput']['input']>>;
  CardType?: InputMaybe<Enum_Additionalproducts_Cardtype>;
  Category?: InputMaybe<Scalars['String']['input']>;
  Company?: InputMaybe<Scalars['ID']['input']>;
  DefaultVariant?: InputMaybe<Scalars['ID']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ExternalId?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  ImageUrl?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Price?: InputMaybe<Scalars['String']['input']>;
  PriceV2?: InputMaybe<PriceInput>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['JSON']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  Variants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type AdditionalProducts = {
  __typename?: 'AdditionalProducts';
  CallToAction?: Maybe<Array<Maybe<AdditionalProductsCallToActionDynamicZone>>>;
  CardType?: Maybe<Enum_Additionalproducts_Cardtype>;
  Category?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Companies>;
  DefaultVariant?: Maybe<Variants>;
  Description?: Maybe<Scalars['String']['output']>;
  ExternalId?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFile>;
  ImageUrl?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  Price?: Maybe<Scalars['String']['output']>;
  PriceV2?: Maybe<Price>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<Scalars['JSON']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  UID?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Variants?: Maybe<Array<Maybe<Variants>>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<AdditionalProducts>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type AdditionalProductsVariantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type AdditionalProductsLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type AdditionalProductsAggregator = {
  __typename?: 'AdditionalProductsAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdditionalProductsCallToActionDynamicZone = ComponentCtaEventCallToAction | ComponentCtaLinkCallToAction;

export type AdditionalProductsConnection = {
  __typename?: 'AdditionalProductsConnection';
  aggregate?: Maybe<AdditionalProductsAggregator>;
  groupBy?: Maybe<AdditionalProductsGroupBy>;
  values?: Maybe<Array<Maybe<AdditionalProducts>>>;
};

export type AdditionalProductsConnectionCardType = {
  __typename?: 'AdditionalProductsConnectionCardType';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionCategory = {
  __typename?: 'AdditionalProductsConnectionCategory';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionCompany = {
  __typename?: 'AdditionalProductsConnectionCompany';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type AdditionalProductsConnectionCreated_At = {
  __typename?: 'AdditionalProductsConnectionCreated_at';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type AdditionalProductsConnectionDefaultVariant = {
  __typename?: 'AdditionalProductsConnectionDefaultVariant';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type AdditionalProductsConnectionDescription = {
  __typename?: 'AdditionalProductsConnectionDescription';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionExternalId = {
  __typename?: 'AdditionalProductsConnectionExternalId';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionId = {
  __typename?: 'AdditionalProductsConnectionId';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type AdditionalProductsConnectionImage = {
  __typename?: 'AdditionalProductsConnectionImage';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type AdditionalProductsConnectionImageUrl = {
  __typename?: 'AdditionalProductsConnectionImageUrl';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionLocale = {
  __typename?: 'AdditionalProductsConnectionLocale';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionName = {
  __typename?: 'AdditionalProductsConnectionName';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionPrice = {
  __typename?: 'AdditionalProductsConnectionPrice';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionPublishedAt = {
  __typename?: 'AdditionalProductsConnectionPublishedAt';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type AdditionalProductsConnectionPublished_At = {
  __typename?: 'AdditionalProductsConnectionPublished_at';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type AdditionalProductsConnectionSlug = {
  __typename?: 'AdditionalProductsConnectionSlug';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionSource = {
  __typename?: 'AdditionalProductsConnectionSource';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type AdditionalProductsConnectionStatus = {
  __typename?: 'AdditionalProductsConnectionStatus';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionUid = {
  __typename?: 'AdditionalProductsConnectionUID';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsConnectionUpdated_At = {
  __typename?: 'AdditionalProductsConnectionUpdated_at';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type AdditionalProductsConnectionUrl = {
  __typename?: 'AdditionalProductsConnectionUrl';
  connection?: Maybe<AdditionalProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalProductsGroupBy = {
  __typename?: 'AdditionalProductsGroupBy';
  CardType?: Maybe<Array<Maybe<AdditionalProductsConnectionCardType>>>;
  Category?: Maybe<Array<Maybe<AdditionalProductsConnectionCategory>>>;
  Company?: Maybe<Array<Maybe<AdditionalProductsConnectionCompany>>>;
  DefaultVariant?: Maybe<Array<Maybe<AdditionalProductsConnectionDefaultVariant>>>;
  Description?: Maybe<Array<Maybe<AdditionalProductsConnectionDescription>>>;
  ExternalId?: Maybe<Array<Maybe<AdditionalProductsConnectionExternalId>>>;
  Image?: Maybe<Array<Maybe<AdditionalProductsConnectionImage>>>;
  ImageUrl?: Maybe<Array<Maybe<AdditionalProductsConnectionImageUrl>>>;
  Name?: Maybe<Array<Maybe<AdditionalProductsConnectionName>>>;
  Price?: Maybe<Array<Maybe<AdditionalProductsConnectionPrice>>>;
  PublishedAt?: Maybe<Array<Maybe<AdditionalProductsConnectionPublishedAt>>>;
  Slug?: Maybe<Array<Maybe<AdditionalProductsConnectionSlug>>>;
  Source?: Maybe<Array<Maybe<AdditionalProductsConnectionSource>>>;
  Status?: Maybe<Array<Maybe<AdditionalProductsConnectionStatus>>>;
  UID?: Maybe<Array<Maybe<AdditionalProductsConnectionUid>>>;
  Url?: Maybe<Array<Maybe<AdditionalProductsConnectionUrl>>>;
  created_at?: Maybe<Array<Maybe<AdditionalProductsConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<AdditionalProductsConnectionId>>>;
  locale?: Maybe<Array<Maybe<AdditionalProductsConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<AdditionalProductsConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<AdditionalProductsConnectionUpdated_At>>>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type ArticleInput = {
  Metadata?: InputMaybe<Scalars['JSON']['input']>;
  Nodes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  RawState?: InputMaybe<Scalars['JSON']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Articles = {
  __typename?: 'Articles';
  Metadata?: Maybe<Scalars['JSON']['output']>;
  Nodes?: Maybe<Array<Maybe<Nodes>>>;
  Products?: Maybe<Array<Maybe<Products>>>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  RawState?: Maybe<Scalars['JSON']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Articles>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type ArticlesNodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ArticlesProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ArticlesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type ArticlesAggregator = {
  __typename?: 'ArticlesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  aggregate?: Maybe<ArticlesAggregator>;
  groupBy?: Maybe<ArticlesGroupBy>;
  values?: Maybe<Array<Maybe<Articles>>>;
};

export type ArticlesConnectionCreated_At = {
  __typename?: 'ArticlesConnectionCreated_at';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticlesConnectionId = {
  __typename?: 'ArticlesConnectionId';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ArticlesConnectionLocale = {
  __typename?: 'ArticlesConnectionLocale';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ArticlesConnectionMetadata = {
  __typename?: 'ArticlesConnectionMetadata';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type ArticlesConnectionPublishedAt = {
  __typename?: 'ArticlesConnectionPublishedAt';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticlesConnectionPublished_At = {
  __typename?: 'ArticlesConnectionPublished_at';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticlesConnectionRawState = {
  __typename?: 'ArticlesConnectionRawState';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type ArticlesConnectionSlug = {
  __typename?: 'ArticlesConnectionSlug';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ArticlesConnectionStatus = {
  __typename?: 'ArticlesConnectionStatus';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ArticlesConnectionTitle = {
  __typename?: 'ArticlesConnectionTitle';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ArticlesConnectionUid = {
  __typename?: 'ArticlesConnectionUID';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ArticlesConnectionUpdated_At = {
  __typename?: 'ArticlesConnectionUpdated_at';
  connection?: Maybe<ArticlesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticlesGroupBy = {
  __typename?: 'ArticlesGroupBy';
  Metadata?: Maybe<Array<Maybe<ArticlesConnectionMetadata>>>;
  PublishedAt?: Maybe<Array<Maybe<ArticlesConnectionPublishedAt>>>;
  RawState?: Maybe<Array<Maybe<ArticlesConnectionRawState>>>;
  Slug?: Maybe<Array<Maybe<ArticlesConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<ArticlesConnectionStatus>>>;
  Title?: Maybe<Array<Maybe<ArticlesConnectionTitle>>>;
  UID?: Maybe<Array<Maybe<ArticlesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<ArticlesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ArticlesConnectionId>>>;
  locale?: Maybe<Array<Maybe<ArticlesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<ArticlesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<ArticlesConnectionUpdated_At>>>;
};

export type Companies = {
  __typename?: 'Companies';
  AdditionalProducts?: Maybe<Array<Maybe<AdditionalProducts>>>;
  Auth0OrgId?: Maybe<Scalars['String']['output']>;
  BannerImage?: Maybe<UploadFile>;
  CompanyLogo?: Maybe<UploadFile>;
  Config?: Maybe<Scalars['JSON']['output']>;
  CrmId?: Maybe<Scalars['String']['output']>;
  CustomHead?: Maybe<Scalars['String']['output']>;
  CustomTheme?: Maybe<Scalars['JSON']['output']>;
  DefaultLocale?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmbedCustomHead?: Maybe<Scalars['String']['output']>;
  FormPages?: Maybe<Array<Maybe<FormPages>>>;
  Forms?: Maybe<Array<Maybe<Forms>>>;
  Locales?: Maybe<Scalars['JSON']['output']>;
  Logo?: Maybe<UploadFile>;
  MediaLibrary?: Maybe<Array<Maybe<UploadFile>>>;
  Modals?: Maybe<Array<Maybe<Modals>>>;
  Name: Scalars['String']['output'];
  PrimaryColor?: Maybe<Scalars['String']['output']>;
  PrivacyPolicy?: Maybe<UploadFile>;
  ProductCollection?: Maybe<Array<Maybe<CompaniesProductCollectionDynamicZone>>>;
  Products?: Maybe<Array<Maybe<Products>>>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  SecondaryColor?: Maybe<Scalars['String']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  SocialLinks?: Maybe<Array<Maybe<ComponentLinksSocialLinks>>>;
  Status?: Maybe<Scalars['String']['output']>;
  Theme?: Maybe<Themes>;
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Companies>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type CompaniesAdditionalProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type CompaniesFormPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type CompaniesFormsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type CompaniesMediaLibraryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type CompaniesModalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type CompaniesProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type CompaniesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type CompaniesAggregator = {
  __typename?: 'CompaniesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  aggregate?: Maybe<CompaniesAggregator>;
  groupBy?: Maybe<CompaniesGroupBy>;
  values?: Maybe<Array<Maybe<Companies>>>;
};

export type CompaniesConnectionAuth0OrgId = {
  __typename?: 'CompaniesConnectionAuth0OrgId';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionBannerImage = {
  __typename?: 'CompaniesConnectionBannerImage';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CompaniesConnectionCompanyLogo = {
  __typename?: 'CompaniesConnectionCompanyLogo';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CompaniesConnectionConfig = {
  __typename?: 'CompaniesConnectionConfig';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type CompaniesConnectionCreated_At = {
  __typename?: 'CompaniesConnectionCreated_at';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type CompaniesConnectionCrmId = {
  __typename?: 'CompaniesConnectionCrmId';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionCustomHead = {
  __typename?: 'CompaniesConnectionCustomHead';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionCustomTheme = {
  __typename?: 'CompaniesConnectionCustomTheme';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type CompaniesConnectionDefaultLocale = {
  __typename?: 'CompaniesConnectionDefaultLocale';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionDescription = {
  __typename?: 'CompaniesConnectionDescription';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionEmbedCustomHead = {
  __typename?: 'CompaniesConnectionEmbedCustomHead';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionId = {
  __typename?: 'CompaniesConnectionId';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CompaniesConnectionLocale = {
  __typename?: 'CompaniesConnectionLocale';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionLocales = {
  __typename?: 'CompaniesConnectionLocales';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type CompaniesConnectionLogo = {
  __typename?: 'CompaniesConnectionLogo';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CompaniesConnectionName = {
  __typename?: 'CompaniesConnectionName';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionPrimaryColor = {
  __typename?: 'CompaniesConnectionPrimaryColor';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionPrivacyPolicy = {
  __typename?: 'CompaniesConnectionPrivacyPolicy';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CompaniesConnectionPublishedAt = {
  __typename?: 'CompaniesConnectionPublishedAt';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type CompaniesConnectionPublished_At = {
  __typename?: 'CompaniesConnectionPublished_at';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type CompaniesConnectionSecondaryColor = {
  __typename?: 'CompaniesConnectionSecondaryColor';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionSlug = {
  __typename?: 'CompaniesConnectionSlug';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionStatus = {
  __typename?: 'CompaniesConnectionStatus';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionTheme = {
  __typename?: 'CompaniesConnectionTheme';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type CompaniesConnectionUid = {
  __typename?: 'CompaniesConnectionUID';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CompaniesConnectionUpdated_At = {
  __typename?: 'CompaniesConnectionUpdated_at';
  connection?: Maybe<CompaniesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type CompaniesGroupBy = {
  __typename?: 'CompaniesGroupBy';
  Auth0OrgId?: Maybe<Array<Maybe<CompaniesConnectionAuth0OrgId>>>;
  BannerImage?: Maybe<Array<Maybe<CompaniesConnectionBannerImage>>>;
  CompanyLogo?: Maybe<Array<Maybe<CompaniesConnectionCompanyLogo>>>;
  Config?: Maybe<Array<Maybe<CompaniesConnectionConfig>>>;
  CrmId?: Maybe<Array<Maybe<CompaniesConnectionCrmId>>>;
  CustomHead?: Maybe<Array<Maybe<CompaniesConnectionCustomHead>>>;
  CustomTheme?: Maybe<Array<Maybe<CompaniesConnectionCustomTheme>>>;
  DefaultLocale?: Maybe<Array<Maybe<CompaniesConnectionDefaultLocale>>>;
  Description?: Maybe<Array<Maybe<CompaniesConnectionDescription>>>;
  EmbedCustomHead?: Maybe<Array<Maybe<CompaniesConnectionEmbedCustomHead>>>;
  Locales?: Maybe<Array<Maybe<CompaniesConnectionLocales>>>;
  Logo?: Maybe<Array<Maybe<CompaniesConnectionLogo>>>;
  Name?: Maybe<Array<Maybe<CompaniesConnectionName>>>;
  PrimaryColor?: Maybe<Array<Maybe<CompaniesConnectionPrimaryColor>>>;
  PrivacyPolicy?: Maybe<Array<Maybe<CompaniesConnectionPrivacyPolicy>>>;
  PublishedAt?: Maybe<Array<Maybe<CompaniesConnectionPublishedAt>>>;
  SecondaryColor?: Maybe<Array<Maybe<CompaniesConnectionSecondaryColor>>>;
  Slug?: Maybe<Array<Maybe<CompaniesConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<CompaniesConnectionStatus>>>;
  Theme?: Maybe<Array<Maybe<CompaniesConnectionTheme>>>;
  UID?: Maybe<Array<Maybe<CompaniesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<CompaniesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<CompaniesConnectionId>>>;
  locale?: Maybe<Array<Maybe<CompaniesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<CompaniesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<CompaniesConnectionUpdated_At>>>;
};

export type CompaniesProductCollectionDynamicZone = ComponentUtilsProductCategory | ComponentUtilsSimpleProduct;

export type CompanyInput = {
  AdditionalProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Auth0OrgId?: InputMaybe<Scalars['String']['input']>;
  BannerImage?: InputMaybe<Scalars['ID']['input']>;
  CompanyLogo?: InputMaybe<Scalars['ID']['input']>;
  Config?: InputMaybe<Scalars['JSON']['input']>;
  CrmId?: InputMaybe<Scalars['String']['input']>;
  CustomHead?: InputMaybe<Scalars['String']['input']>;
  CustomTheme?: InputMaybe<Scalars['JSON']['input']>;
  DefaultLocale?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  EmbedCustomHead?: InputMaybe<Scalars['String']['input']>;
  FormPages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Forms?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Locales?: InputMaybe<Scalars['JSON']['input']>;
  Logo?: InputMaybe<Scalars['ID']['input']>;
  MediaLibrary?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Modals?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Name: Scalars['String']['input'];
  PrimaryColor?: InputMaybe<Scalars['String']['input']>;
  PrivacyPolicy?: InputMaybe<Scalars['ID']['input']>;
  ProductCollection?: InputMaybe<Array<Scalars['CompaniesProductCollectionDynamicZoneInput']['input']>>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  SecondaryColor?: InputMaybe<Scalars['String']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  SocialLinks?: InputMaybe<Array<InputMaybe<ComponentLinksSocialLinkInput>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Theme?: InputMaybe<Scalars['ID']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyMediaLibraryResponse = {
  __typename?: 'CompanyMediaLibraryResponse';
  nodes: Array<UploadFile>;
  pageInfo: PageInfo;
};

export type Compare = {
  __typename?: 'Compare';
  isEqual: Scalars['Boolean']['output'];
};

export type ComponentAiChat = {
  __typename?: 'ComponentAiChat';
  AgentID: Scalars['Int']['output'];
  Avatar?: Maybe<UploadFile>;
  InitialMessage: Scalars['String']['output'];
  Suggestions?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentAiChatInput = {
  AgentID: Scalars['Int']['input'];
  Avatar?: InputMaybe<Scalars['ID']['input']>;
  InitialMessage: Scalars['String']['input'];
  Suggestions?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentConsentsEmail = {
  __typename?: 'ComponentConsentsEmail';
  CustomText?: Maybe<Scalars['String']['output']>;
  /** Set the consent to 'implicit' to hide the check box. The consent is considered given on submit. */
  ImplicitConsent?: Maybe<Scalars['Boolean']['output']>;
  IsRequired: Scalars['Boolean']['output'];
  PrivacyPolicyURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentConsentsEmailInput = {
  CustomText?: InputMaybe<Scalars['String']['input']>;
  ImplicitConsent?: InputMaybe<Scalars['Boolean']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  PrivacyPolicyURL?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContentAdditionalProduct = {
  __typename?: 'ComponentContentAdditionalProduct';
  Additional_product?: Maybe<AdditionalProducts>;
  Selected_variant?: Maybe<Variants>;
  id: Scalars['ID']['output'];
};

export type ComponentContentAdditionalProductInput = {
  Additional_product?: InputMaybe<Scalars['ID']['input']>;
  Selected_variant?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentContentArticle = {
  __typename?: 'ComponentContentArticle';
  Article?: Maybe<Articles>;
  id: Scalars['ID']['output'];
};

export type ComponentContentArticleInput = {
  Article?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentContentStory = {
  __typename?: 'ComponentContentStory';
  Story?: Maybe<Stories>;
  id: Scalars['ID']['output'];
};

export type ComponentContentStoryInput = {
  Story?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCtaEventCallToAction = {
  __typename?: 'ComponentCtaEventCallToAction';
  Text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCtaEventCallToActionInput = {
  Text: Scalars['String']['input'];
};

export type ComponentCtaLinkCallToAction = {
  __typename?: 'ComponentCtaLinkCallToAction';
  Redirection_Type: RedirectionType;
  Text: Scalars['String']['output'];
  Url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCtaLinkCallToActionInput = {
  Redirection_Type?: InputMaybe<RedirectionType>;
  Text: Scalars['String']['input'];
  Url: Scalars['String']['input'];
};

export type ComponentCtaLockedContentCallToAction = {
  __typename?: 'ComponentCtaLockedContentCallToAction';
  RegistrationModule?: Maybe<Modules>;
  Text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentCtaLockedContentCallToActionInput = {
  RegistrationModule?: InputMaybe<Scalars['ID']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDisplayRichText = {
  __typename?: 'ComponentDisplayRichText';
  RichText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDisplayRichTextInput = {
  RichText: Scalars['String']['input'];
};

export type ComponentElementsLoader = {
  __typename?: 'ComponentElementsLoader';
  Description?: Maybe<Scalars['String']['output']>;
  Duration: Scalars['Int']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentElementsLoaderInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Duration?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentFormFieldsDateInput = {
  __typename?: 'ComponentFormFieldsDateInput';
  DefaultValue?: Maybe<Scalars['Date']['output']>;
  IsRequired: Scalars['Boolean']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentFormFieldsDateInputInput = {
  DefaultValue?: InputMaybe<Scalars['Date']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
};

export type ComponentFormFieldsFileInput = {
  __typename?: 'ComponentFormFieldsFileInput';
  AcceptedFileTypes: Scalars['JSON']['output'];
  IsRequired: Scalars['Boolean']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentFormFieldsFileInputInput = {
  AcceptedFileTypes: Scalars['JSON']['input'];
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
};

export type ComponentFormFieldsInput = {
  __typename?: 'ComponentFormFieldsInput';
  DefaultValue?: Maybe<Scalars['String']['output']>;
  IsRequired: Scalars['Boolean']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  Placeholder?: Maybe<Scalars['String']['output']>;
  Type: Enum_Componentformfieldsinput_Type;
  id: Scalars['ID']['output'];
};

export type ComponentFormFieldsInputInput = {
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Placeholder?: InputMaybe<Scalars['String']['input']>;
  Type: Enum_Componentformfieldsinput_Type;
};

export type ComponentFormFieldsSingleSelect = {
  __typename?: 'ComponentFormFieldsSingleSelect';
  DisplayType: SingleSelectDisplayType;
  IsRequired: Scalars['Boolean']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  Placeholder?: Maybe<Scalars['String']['output']>;
  Values: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentFormFieldsSingleSelectInput = {
  DisplayType?: InputMaybe<SingleSelectDisplayType>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Placeholder?: InputMaybe<Scalars['String']['input']>;
  Values: Scalars['JSON']['input'];
};

export type ComponentFormPagesFormPage = {
  __typename?: 'ComponentFormPagesFormPage';
  FormPage?: Maybe<FormPages>;
  id: Scalars['ID']['output'];
};

export type ComponentFormPagesFormPageInput = {
  FormPage?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentFormTemplatesNewsletter = {
  __typename?: 'ComponentFormTemplatesNewsletter';
  Description?: Maybe<Scalars['String']['output']>;
  EmailConsent?: Maybe<ComponentConsentsEmail>;
  IsNameRequired: Scalars['Boolean']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentFormTemplatesNewsletterInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  EmailConsent?: InputMaybe<ComponentConsentsEmailInput>;
  IsNameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentFormTemplatesRegistration = {
  __typename?: 'ComponentFormTemplatesRegistration';
  CtaText?: Maybe<Scalars['String']['output']>;
  EmailConsent?: Maybe<ComponentConsentsEmail>;
  Identifier: Enum_Componentformtemplatesregistration_Identifier;
  IsRequired: Scalars['Boolean']['output'];
  WithCGU?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentFormTemplatesRegistrationInput = {
  CtaText?: InputMaybe<Scalars['String']['input']>;
  EmailConsent?: InputMaybe<ComponentConsentsEmailInput>;
  Identifier?: InputMaybe<Enum_Componentformtemplatesregistration_Identifier>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  WithCGU?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentFormTemplatesReview = {
  __typename?: 'ComponentFormTemplatesReview';
  HasComment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentFormTemplatesReviewInput = {
  HasComment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentFormsForm = {
  __typename?: 'ComponentFormsForm';
  Form?: Maybe<Forms>;
  id: Scalars['ID']['output'];
};

export type ComponentFormsFormInput = {
  Form?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentLinksProductLinkInput = {
  LinksTo?: InputMaybe<Enum_Componentlinksproductlinks_Linksto>;
  Url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLinksProductLinks = {
  __typename?: 'ComponentLinksProductLinks';
  LinksTo?: Maybe<Enum_Componentlinksproductlinks_Linksto>;
  Url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentLinksSocialLinkInput = {
  LinksTo?: InputMaybe<Enum_Componentlinkssociallinks_Linksto>;
  Url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLinksSocialLinks = {
  __typename?: 'ComponentLinksSocialLinks';
  LinksTo?: Maybe<Enum_Componentlinkssociallinks_Linksto>;
  Url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentPagesFlowPage = {
  __typename?: 'ComponentPagesFlowPage';
  FlowPage?: Maybe<FlowPages>;
  id: Scalars['ID']['output'];
};

export type ComponentPagesFlowPageInput = {
  FlowPage?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentUtilsModule = {
  __typename?: 'ComponentUtilsModule';
  Module?: Maybe<Modules>;
  id: Scalars['ID']['output'];
};

export type ComponentUtilsModuleInput = {
  Module?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentUtilsProductCategory = {
  __typename?: 'ComponentUtilsProductCategory';
  IsCollapsible?: Maybe<Scalars['Boolean']['output']>;
  Products?: Maybe<Array<Maybe<ComponentUtilsSimpleProduct>>>;
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentUtilsProductCategoryInput = {
  IsCollapsible?: InputMaybe<Scalars['Boolean']['input']>;
  Products?: InputMaybe<Array<InputMaybe<ComponentUtilsSimpleProductInput>>>;
  Title: Scalars['String']['input'];
};

export type ComponentUtilsSimpleProduct = {
  __typename?: 'ComponentUtilsSimpleProduct';
  Product?: Maybe<Products>;
  id: Scalars['ID']['output'];
};

export type ComponentUtilsSimpleProductInput = {
  Product?: InputMaybe<Scalars['ID']['input']>;
};

export enum Enum_Additionalproducts_Cardtype {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical'
}

export enum Enum_Componentformfieldsinput_Type {
  Box = 'box',
  Email = 'email',
  Number = 'number',
  Password = 'password',
  Rating = 'rating',
  Tel = 'tel',
  Text = 'text'
}

export enum Enum_Componentformtemplatesregistration_Identifier {
  Email = 'email',
  PhoneNumber = 'phoneNumber'
}

export enum Enum_Componentlinksproductlinks_Linksto {
  AdditionalProducts = 'AdditionalProducts',
  BrandPage = 'BrandPage',
  PdfManual = 'PDFManual'
}

export enum Enum_Componentlinkssociallinks_Linksto {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  MailTo = 'MailTo',
  Twitter = 'Twitter',
  Website = 'Website'
}

export enum Enum_Flowpages_Display {
  Divider = 'divider',
  Sell = 'sell',
  Success = 'success',
  Welcome = 'welcome'
}

export enum Enum_Forms_Type {
  Custom = 'custom',
  Newsletter = 'newsletter',
  ProductRegistration = 'productRegistration',
  Review = 'review',
  Survey = 'survey',
  UserRegistration = 'userRegistration'
}

export enum Enum_Modals_Trigger {
  ChangeLocale = 'changeLocale',
  CompanyFirstVisit = 'companyFirstVisit',
  CtaClick = 'ctaClick',
  DisplayStoryPage = 'displayStoryPage',
  EnterArticle = 'enterArticle',
  EnterStory = 'enterStory',
  ExitArticle = 'exitArticle',
  ExitStory = 'exitStory',
  FirstStory = 'firstStory',
  FirstStoryPage = 'firstStoryPage',
  FirstVisit = 'firstVisit',
  LastStory = 'lastStory',
  LastStoryPage = 'lastStoryPage',
  LockedModuleClick = 'lockedModuleClick',
  OnModalFailureClose = 'onModalFailureClose',
  OnModalSuccessClose = 'onModalSuccessClose',
  OnSearch = 'onSearch',
  ProductFirstVisit = 'productFirstVisit'
}

export enum Enum_Modals_Type {
  Form = 'form',
  LockedExperience = 'lockedExperience',
  Sell = 'sell',
  Text = 'text'
}

export enum Enum_Modules_Type {
  AdditionalProducts = 'additionalProducts',
  AiChat = 'aiChat',
  Articles = 'articles',
  Cta = 'cta',
  Faq = 'faq',
  Flow = 'flow',
  Heading = 'heading',
  Stories = 'stories',
  Survey = 'survey'
}

export enum Enum_Nodes_Type {
  AdditionalProduct = 'additionalProduct',
  BulletedList = 'bulletedList',
  Callout = 'callout',
  CheckList = 'checkList',
  CheckListItem = 'checkListItem',
  Embed = 'embed',
  EmptyText = 'emptyText',
  Heading = 'heading',
  Image = 'image',
  Link = 'link',
  ListItem = 'listItem',
  OrderedList = 'orderedList',
  Paragraph = 'paragraph',
  Table = 'table',
  TableCell = 'tableCell',
  TableHeaderCell = 'tableHeaderCell',
  TableRow = 'tableRow',
  Text = 'text'
}

export enum Enum_Products_Productdisplaytype {
  Banner = 'banner',
  Rounded = 'rounded',
  Squared = 'squared'
}

export enum Enum_Themes_Homepage_Picture {
  CompanyLogo = 'companyLogo',
  Product = 'product'
}

export enum Enum_Themes_Modal_Picture {
  CompanyLogo = 'companyLogo',
  Product = 'product'
}

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  mime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  related?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size: Scalars['Float']['input'];
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type FileRelation = {
  __typename?: 'FileRelation';
  field: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  refId: Scalars['ID']['output'];
};

export type FlowPageInput = {
  AdditionalProduct?: InputMaybe<ComponentContentAdditionalProductInput>;
  AllowExit?: InputMaybe<Scalars['Boolean']['input']>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Display?: InputMaybe<Enum_Flowpages_Display>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Loader?: InputMaybe<ComponentElementsLoaderInput>;
  Product?: InputMaybe<Scalars['ID']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Registration?: InputMaybe<ComponentFormsFormInput>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type FlowPages = {
  __typename?: 'FlowPages';
  AdditionalProduct?: Maybe<ComponentContentAdditionalProduct>;
  AllowExit: Scalars['Boolean']['output'];
  CtaText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Display: Enum_Flowpages_Display;
  Image?: Maybe<UploadFile>;
  Loader?: Maybe<ComponentElementsLoader>;
  Product?: Maybe<Products>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Registration?: Maybe<ComponentFormsForm>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<FlowPages>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type FlowPagesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type FlowPagesAggregator = {
  __typename?: 'FlowPagesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FlowPagesConnection = {
  __typename?: 'FlowPagesConnection';
  aggregate?: Maybe<FlowPagesAggregator>;
  groupBy?: Maybe<FlowPagesGroupBy>;
  values?: Maybe<Array<Maybe<FlowPages>>>;
};

export type FlowPagesConnectionAdditionalProduct = {
  __typename?: 'FlowPagesConnectionAdditionalProduct';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FlowPagesConnectionAllowExit = {
  __typename?: 'FlowPagesConnectionAllowExit';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type FlowPagesConnectionCreated_At = {
  __typename?: 'FlowPagesConnectionCreated_at';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FlowPagesConnectionCtaText = {
  __typename?: 'FlowPagesConnectionCtaText';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionDescription = {
  __typename?: 'FlowPagesConnectionDescription';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionDisplay = {
  __typename?: 'FlowPagesConnectionDisplay';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionId = {
  __typename?: 'FlowPagesConnectionId';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FlowPagesConnectionImage = {
  __typename?: 'FlowPagesConnectionImage';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FlowPagesConnectionLoader = {
  __typename?: 'FlowPagesConnectionLoader';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FlowPagesConnectionLocale = {
  __typename?: 'FlowPagesConnectionLocale';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionProduct = {
  __typename?: 'FlowPagesConnectionProduct';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FlowPagesConnectionPublishedAt = {
  __typename?: 'FlowPagesConnectionPublishedAt';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FlowPagesConnectionPublished_At = {
  __typename?: 'FlowPagesConnectionPublished_at';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FlowPagesConnectionRegistration = {
  __typename?: 'FlowPagesConnectionRegistration';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FlowPagesConnectionSlug = {
  __typename?: 'FlowPagesConnectionSlug';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionStatus = {
  __typename?: 'FlowPagesConnectionStatus';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionTitle = {
  __typename?: 'FlowPagesConnectionTitle';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionUid = {
  __typename?: 'FlowPagesConnectionUID';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FlowPagesConnectionUpdated_At = {
  __typename?: 'FlowPagesConnectionUpdated_at';
  connection?: Maybe<FlowPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FlowPagesGroupBy = {
  __typename?: 'FlowPagesGroupBy';
  AdditionalProduct?: Maybe<Array<Maybe<FlowPagesConnectionAdditionalProduct>>>;
  AllowExit?: Maybe<Array<Maybe<FlowPagesConnectionAllowExit>>>;
  CtaText?: Maybe<Array<Maybe<FlowPagesConnectionCtaText>>>;
  Description?: Maybe<Array<Maybe<FlowPagesConnectionDescription>>>;
  Display?: Maybe<Array<Maybe<FlowPagesConnectionDisplay>>>;
  Image?: Maybe<Array<Maybe<FlowPagesConnectionImage>>>;
  Loader?: Maybe<Array<Maybe<FlowPagesConnectionLoader>>>;
  Product?: Maybe<Array<Maybe<FlowPagesConnectionProduct>>>;
  PublishedAt?: Maybe<Array<Maybe<FlowPagesConnectionPublishedAt>>>;
  Registration?: Maybe<Array<Maybe<FlowPagesConnectionRegistration>>>;
  Slug?: Maybe<Array<Maybe<FlowPagesConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<FlowPagesConnectionStatus>>>;
  Title?: Maybe<Array<Maybe<FlowPagesConnectionTitle>>>;
  UID?: Maybe<Array<Maybe<FlowPagesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<FlowPagesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<FlowPagesConnectionId>>>;
  locale?: Maybe<Array<Maybe<FlowPagesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<FlowPagesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<FlowPagesConnectionUpdated_At>>>;
};

export type FormInput = {
  Company?: InputMaybe<Scalars['ID']['input']>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  Elements?: InputMaybe<Array<Scalars['FormsElementsDynamicZoneInput']['input']>>;
  IsProductRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  Name: Scalars['String']['input'];
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Type: Enum_Forms_Type;
  UID?: InputMaybe<Scalars['String']['input']>;
  WithCGU?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type FormPageInput = {
  Company?: InputMaybe<Scalars['ID']['input']>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  Elements: Array<Scalars['FormPagesElementsDynamicZoneInput']['input']>;
  Name: Scalars['String']['input'];
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  WithCGU?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type FormPages = {
  __typename?: 'FormPages';
  Company?: Maybe<Companies>;
  CtaText?: Maybe<Scalars['String']['output']>;
  Elements: Array<Maybe<FormPagesElementsDynamicZone>>;
  Name: Scalars['String']['output'];
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  UID?: Maybe<Scalars['String']['output']>;
  WithCGU: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<FormPages>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type FormPagesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormPagesAggregator = {
  __typename?: 'FormPagesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FormPagesConnection = {
  __typename?: 'FormPagesConnection';
  aggregate?: Maybe<FormPagesAggregator>;
  groupBy?: Maybe<FormPagesGroupBy>;
  values?: Maybe<Array<Maybe<FormPages>>>;
};

export type FormPagesConnectionCompany = {
  __typename?: 'FormPagesConnectionCompany';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FormPagesConnectionCreated_At = {
  __typename?: 'FormPagesConnectionCreated_at';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormPagesConnectionCtaText = {
  __typename?: 'FormPagesConnectionCtaText';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormPagesConnectionId = {
  __typename?: 'FormPagesConnectionId';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FormPagesConnectionLocale = {
  __typename?: 'FormPagesConnectionLocale';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormPagesConnectionName = {
  __typename?: 'FormPagesConnectionName';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormPagesConnectionPublishedAt = {
  __typename?: 'FormPagesConnectionPublishedAt';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormPagesConnectionPublished_At = {
  __typename?: 'FormPagesConnectionPublished_at';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormPagesConnectionSlug = {
  __typename?: 'FormPagesConnectionSlug';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormPagesConnectionStatus = {
  __typename?: 'FormPagesConnectionStatus';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormPagesConnectionUid = {
  __typename?: 'FormPagesConnectionUID';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormPagesConnectionUpdated_At = {
  __typename?: 'FormPagesConnectionUpdated_at';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormPagesConnectionWithCgu = {
  __typename?: 'FormPagesConnectionWithCGU';
  connection?: Maybe<FormPagesConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type FormPagesElementsDynamicZone = ComponentConsentsEmail | ComponentDisplayRichText | ComponentFormFieldsDateInput | ComponentFormFieldsFileInput | ComponentFormFieldsInput | ComponentFormFieldsSingleSelect;

export type FormPagesGroupBy = {
  __typename?: 'FormPagesGroupBy';
  Company?: Maybe<Array<Maybe<FormPagesConnectionCompany>>>;
  CtaText?: Maybe<Array<Maybe<FormPagesConnectionCtaText>>>;
  Name?: Maybe<Array<Maybe<FormPagesConnectionName>>>;
  PublishedAt?: Maybe<Array<Maybe<FormPagesConnectionPublishedAt>>>;
  Slug?: Maybe<Array<Maybe<FormPagesConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<FormPagesConnectionStatus>>>;
  UID?: Maybe<Array<Maybe<FormPagesConnectionUid>>>;
  WithCGU?: Maybe<Array<Maybe<FormPagesConnectionWithCgu>>>;
  created_at?: Maybe<Array<Maybe<FormPagesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<FormPagesConnectionId>>>;
  locale?: Maybe<Array<Maybe<FormPagesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<FormPagesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<FormPagesConnectionUpdated_At>>>;
};

export type Forms = {
  __typename?: 'Forms';
  Company?: Maybe<Companies>;
  CtaText?: Maybe<Scalars['String']['output']>;
  Elements?: Maybe<Array<Maybe<FormsElementsDynamicZone>>>;
  IsProductRegistration: Scalars['Boolean']['output'];
  Name: Scalars['String']['output'];
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Type: Enum_Forms_Type;
  UID?: Maybe<Scalars['String']['output']>;
  WithCGU: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Forms>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type FormsLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type FormsAggregator = {
  __typename?: 'FormsAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FormsConnection = {
  __typename?: 'FormsConnection';
  aggregate?: Maybe<FormsAggregator>;
  groupBy?: Maybe<FormsGroupBy>;
  values?: Maybe<Array<Maybe<Forms>>>;
};

export type FormsConnectionCompany = {
  __typename?: 'FormsConnectionCompany';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FormsConnectionCreated_At = {
  __typename?: 'FormsConnectionCreated_at';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormsConnectionCtaText = {
  __typename?: 'FormsConnectionCtaText';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionId = {
  __typename?: 'FormsConnectionId';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type FormsConnectionIsProductRegistration = {
  __typename?: 'FormsConnectionIsProductRegistration';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type FormsConnectionLocale = {
  __typename?: 'FormsConnectionLocale';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionName = {
  __typename?: 'FormsConnectionName';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionPublishedAt = {
  __typename?: 'FormsConnectionPublishedAt';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormsConnectionPublished_At = {
  __typename?: 'FormsConnectionPublished_at';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormsConnectionSlug = {
  __typename?: 'FormsConnectionSlug';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionStatus = {
  __typename?: 'FormsConnectionStatus';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionType = {
  __typename?: 'FormsConnectionType';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionUid = {
  __typename?: 'FormsConnectionUID';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type FormsConnectionUpdated_At = {
  __typename?: 'FormsConnectionUpdated_at';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type FormsConnectionWithCgu = {
  __typename?: 'FormsConnectionWithCGU';
  connection?: Maybe<FormsConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type FormsElementsDynamicZone = ComponentConsentsEmail | ComponentDisplayRichText | ComponentFormFieldsDateInput | ComponentFormFieldsFileInput | ComponentFormFieldsInput | ComponentFormFieldsSingleSelect | ComponentFormPagesFormPage | ComponentFormTemplatesNewsletter | ComponentFormTemplatesRegistration | ComponentFormTemplatesReview;

export type FormsGroupBy = {
  __typename?: 'FormsGroupBy';
  Company?: Maybe<Array<Maybe<FormsConnectionCompany>>>;
  CtaText?: Maybe<Array<Maybe<FormsConnectionCtaText>>>;
  IsProductRegistration?: Maybe<Array<Maybe<FormsConnectionIsProductRegistration>>>;
  Name?: Maybe<Array<Maybe<FormsConnectionName>>>;
  PublishedAt?: Maybe<Array<Maybe<FormsConnectionPublishedAt>>>;
  Slug?: Maybe<Array<Maybe<FormsConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<FormsConnectionStatus>>>;
  Type?: Maybe<Array<Maybe<FormsConnectionType>>>;
  UID?: Maybe<Array<Maybe<FormsConnectionUid>>>;
  WithCGU?: Maybe<Array<Maybe<FormsConnectionWithCgu>>>;
  created_at?: Maybe<Array<Maybe<FormsConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<FormsConnectionId>>>;
  locale?: Maybe<Array<Maybe<FormsConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<FormsConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<FormsConnectionUpdated_At>>>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type I18NLocaleAggregator = {
  __typename?: 'I18NLocaleAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type I18NLocaleConnection = {
  __typename?: 'I18NLocaleConnection';
  aggregate?: Maybe<I18NLocaleAggregator>;
  groupBy?: Maybe<I18NLocaleGroupBy>;
  values?: Maybe<Array<Maybe<I18NLocale>>>;
};

export type I18NLocaleConnectionCode = {
  __typename?: 'I18NLocaleConnectionCode';
  connection?: Maybe<I18NLocaleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type I18NLocaleConnectionCreated_At = {
  __typename?: 'I18NLocaleConnectionCreated_at';
  connection?: Maybe<I18NLocaleConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleConnectionId = {
  __typename?: 'I18NLocaleConnectionId';
  connection?: Maybe<I18NLocaleConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleConnectionName = {
  __typename?: 'I18NLocaleConnectionName';
  connection?: Maybe<I18NLocaleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type I18NLocaleConnectionUpdated_At = {
  __typename?: 'I18NLocaleConnectionUpdated_at';
  connection?: Maybe<I18NLocaleConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleGroupBy = {
  __typename?: 'I18NLocaleGroupBy';
  code?: Maybe<Array<Maybe<I18NLocaleConnectionCode>>>;
  created_at?: Maybe<Array<Maybe<I18NLocaleConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<I18NLocaleConnectionId>>>;
  name?: Maybe<Array<Maybe<I18NLocaleConnectionName>>>;
  updated_at?: Maybe<Array<Maybe<I18NLocaleConnectionUpdated_At>>>;
};

export type InputId = {
  id: Scalars['ID']['input'];
};

export type LocaleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type ModalInput = {
  Company?: InputMaybe<Scalars['ID']['input']>;
  Elements?: InputMaybe<Array<Scalars['ModalsElementsDynamicZoneInput']['input']>>;
  Filter?: InputMaybe<Scalars['JSON']['input']>;
  Name: Scalars['String']['input'];
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Trigger: Enum_Modals_Trigger;
  Type: Enum_Modals_Type;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Modals = {
  __typename?: 'Modals';
  Company?: Maybe<Companies>;
  Elements?: Maybe<Array<Maybe<ModalsElementsDynamicZone>>>;
  Filter?: Maybe<Scalars['JSON']['output']>;
  Name: Scalars['String']['output'];
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Trigger: Enum_Modals_Trigger;
  Type: Enum_Modals_Type;
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Modals>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type ModalsLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type ModalsAggregator = {
  __typename?: 'ModalsAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ModalsConnection = {
  __typename?: 'ModalsConnection';
  aggregate?: Maybe<ModalsAggregator>;
  groupBy?: Maybe<ModalsGroupBy>;
  values?: Maybe<Array<Maybe<Modals>>>;
};

export type ModalsConnectionCompany = {
  __typename?: 'ModalsConnectionCompany';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModalsConnectionCreated_At = {
  __typename?: 'ModalsConnectionCreated_at';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModalsConnectionFilter = {
  __typename?: 'ModalsConnectionFilter';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type ModalsConnectionId = {
  __typename?: 'ModalsConnectionId';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModalsConnectionLocale = {
  __typename?: 'ModalsConnectionLocale';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModalsConnectionName = {
  __typename?: 'ModalsConnectionName';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModalsConnectionPublishedAt = {
  __typename?: 'ModalsConnectionPublishedAt';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModalsConnectionPublished_At = {
  __typename?: 'ModalsConnectionPublished_at';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModalsConnectionStatus = {
  __typename?: 'ModalsConnectionStatus';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModalsConnectionTrigger = {
  __typename?: 'ModalsConnectionTrigger';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModalsConnectionType = {
  __typename?: 'ModalsConnectionType';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModalsConnectionUid = {
  __typename?: 'ModalsConnectionUID';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModalsConnectionUpdated_At = {
  __typename?: 'ModalsConnectionUpdated_at';
  connection?: Maybe<ModalsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModalsElementsDynamicZone = ComponentContentAdditionalProduct | ComponentCtaEventCallToAction | ComponentCtaLinkCallToAction | ComponentCtaLockedContentCallToAction | ComponentDisplayRichText | ComponentFormsForm;

export type ModalsGroupBy = {
  __typename?: 'ModalsGroupBy';
  Company?: Maybe<Array<Maybe<ModalsConnectionCompany>>>;
  Filter?: Maybe<Array<Maybe<ModalsConnectionFilter>>>;
  Name?: Maybe<Array<Maybe<ModalsConnectionName>>>;
  PublishedAt?: Maybe<Array<Maybe<ModalsConnectionPublishedAt>>>;
  Status?: Maybe<Array<Maybe<ModalsConnectionStatus>>>;
  Trigger?: Maybe<Array<Maybe<ModalsConnectionTrigger>>>;
  Type?: Maybe<Array<Maybe<ModalsConnectionType>>>;
  UID?: Maybe<Array<Maybe<ModalsConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<ModalsConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ModalsConnectionId>>>;
  locale?: Maybe<Array<Maybe<ModalsConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<ModalsConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<ModalsConnectionUpdated_At>>>;
};

export enum ModuleDisplayType {
  Banner = 'banner',
  List = 'list',
  RoundGallery = 'roundGallery',
  SquareGallery = 'squareGallery'
}

export type ModuleInput = {
  Content?: InputMaybe<Array<Scalars['ModulesContentDynamicZoneInput']['input']>>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  DisplayType?: InputMaybe<ModuleDisplayType>;
  Icon?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  IsLocked?: InputMaybe<Scalars['Boolean']['input']>;
  Product?: InputMaybe<Scalars['ID']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Subtitle?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
  Type: Enum_Modules_Type;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Modules = {
  __typename?: 'Modules';
  Content?: Maybe<Array<Maybe<ModulesContentDynamicZone>>>;
  CtaText?: Maybe<Scalars['String']['output']>;
  DisplayType: ModuleDisplayType;
  Icon: Scalars['String']['output'];
  Image?: Maybe<UploadFile>;
  IsLocked: Scalars['Boolean']['output'];
  Product?: Maybe<Products>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Type: Enum_Modules_Type;
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Modules>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type ModulesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type ModulesAggregator = {
  __typename?: 'ModulesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ModulesConnection = {
  __typename?: 'ModulesConnection';
  aggregate?: Maybe<ModulesAggregator>;
  groupBy?: Maybe<ModulesGroupBy>;
  values?: Maybe<Array<Maybe<Modules>>>;
};

export type ModulesConnectionCreated_At = {
  __typename?: 'ModulesConnectionCreated_at';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModulesConnectionCtaText = {
  __typename?: 'ModulesConnectionCtaText';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionDisplayType = {
  __typename?: 'ModulesConnectionDisplayType';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionIcon = {
  __typename?: 'ModulesConnectionIcon';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionId = {
  __typename?: 'ModulesConnectionId';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModulesConnectionImage = {
  __typename?: 'ModulesConnectionImage';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModulesConnectionIsLocked = {
  __typename?: 'ModulesConnectionIsLocked';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type ModulesConnectionLocale = {
  __typename?: 'ModulesConnectionLocale';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionProduct = {
  __typename?: 'ModulesConnectionProduct';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ModulesConnectionPublishedAt = {
  __typename?: 'ModulesConnectionPublishedAt';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModulesConnectionPublished_At = {
  __typename?: 'ModulesConnectionPublished_at';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModulesConnectionStatus = {
  __typename?: 'ModulesConnectionStatus';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionSubtitle = {
  __typename?: 'ModulesConnectionSubtitle';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionTitle = {
  __typename?: 'ModulesConnectionTitle';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionType = {
  __typename?: 'ModulesConnectionType';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionUid = {
  __typename?: 'ModulesConnectionUID';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ModulesConnectionUpdated_At = {
  __typename?: 'ModulesConnectionUpdated_at';
  connection?: Maybe<ModulesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ModulesContentDynamicZone = ComponentAiChat | ComponentContentAdditionalProduct | ComponentContentArticle | ComponentContentStory | ComponentCtaEventCallToAction | ComponentCtaLinkCallToAction | ComponentFormsForm | ComponentPagesFlowPage;

export type ModulesGroupBy = {
  __typename?: 'ModulesGroupBy';
  CtaText?: Maybe<Array<Maybe<ModulesConnectionCtaText>>>;
  DisplayType?: Maybe<Array<Maybe<ModulesConnectionDisplayType>>>;
  Icon?: Maybe<Array<Maybe<ModulesConnectionIcon>>>;
  Image?: Maybe<Array<Maybe<ModulesConnectionImage>>>;
  IsLocked?: Maybe<Array<Maybe<ModulesConnectionIsLocked>>>;
  Product?: Maybe<Array<Maybe<ModulesConnectionProduct>>>;
  PublishedAt?: Maybe<Array<Maybe<ModulesConnectionPublishedAt>>>;
  Status?: Maybe<Array<Maybe<ModulesConnectionStatus>>>;
  Subtitle?: Maybe<Array<Maybe<ModulesConnectionSubtitle>>>;
  Title?: Maybe<Array<Maybe<ModulesConnectionTitle>>>;
  Type?: Maybe<Array<Maybe<ModulesConnectionType>>>;
  UID?: Maybe<Array<Maybe<ModulesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<ModulesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ModulesConnectionId>>>;
  locale?: Maybe<Array<Maybe<ModulesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<ModulesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<ModulesConnectionUpdated_At>>>;
};

export type Morph = AdditionalProducts | AdditionalProductsAggregator | AdditionalProductsConnection | AdditionalProductsConnectionCardType | AdditionalProductsConnectionCategory | AdditionalProductsConnectionCompany | AdditionalProductsConnectionCreated_At | AdditionalProductsConnectionDefaultVariant | AdditionalProductsConnectionDescription | AdditionalProductsConnectionExternalId | AdditionalProductsConnectionId | AdditionalProductsConnectionImage | AdditionalProductsConnectionImageUrl | AdditionalProductsConnectionLocale | AdditionalProductsConnectionName | AdditionalProductsConnectionPrice | AdditionalProductsConnectionPublishedAt | AdditionalProductsConnectionPublished_At | AdditionalProductsConnectionSlug | AdditionalProductsConnectionSource | AdditionalProductsConnectionStatus | AdditionalProductsConnectionUid | AdditionalProductsConnectionUpdated_At | AdditionalProductsConnectionUrl | AdditionalProductsGroupBy | Articles | ArticlesAggregator | ArticlesConnection | ArticlesConnectionCreated_At | ArticlesConnectionId | ArticlesConnectionLocale | ArticlesConnectionMetadata | ArticlesConnectionPublishedAt | ArticlesConnectionPublished_At | ArticlesConnectionRawState | ArticlesConnectionSlug | ArticlesConnectionStatus | ArticlesConnectionTitle | ArticlesConnectionUid | ArticlesConnectionUpdated_At | ArticlesGroupBy | Companies | CompaniesAggregator | CompaniesConnection | CompaniesConnectionAuth0OrgId | CompaniesConnectionBannerImage | CompaniesConnectionCompanyLogo | CompaniesConnectionConfig | CompaniesConnectionCreated_At | CompaniesConnectionCrmId | CompaniesConnectionCustomHead | CompaniesConnectionCustomTheme | CompaniesConnectionDefaultLocale | CompaniesConnectionDescription | CompaniesConnectionEmbedCustomHead | CompaniesConnectionId | CompaniesConnectionLocale | CompaniesConnectionLocales | CompaniesConnectionLogo | CompaniesConnectionName | CompaniesConnectionPrimaryColor | CompaniesConnectionPrivacyPolicy | CompaniesConnectionPublishedAt | CompaniesConnectionPublished_At | CompaniesConnectionSecondaryColor | CompaniesConnectionSlug | CompaniesConnectionStatus | CompaniesConnectionTheme | CompaniesConnectionUid | CompaniesConnectionUpdated_At | CompaniesGroupBy | CompanyMediaLibraryResponse | Compare | ComponentAiChat | ComponentConsentsEmail | ComponentContentAdditionalProduct | ComponentContentArticle | ComponentContentStory | ComponentCtaEventCallToAction | ComponentCtaLinkCallToAction | ComponentCtaLockedContentCallToAction | ComponentDisplayRichText | ComponentElementsLoader | ComponentFormFieldsDateInput | ComponentFormFieldsFileInput | ComponentFormFieldsInput | ComponentFormFieldsSingleSelect | ComponentFormPagesFormPage | ComponentFormTemplatesNewsletter | ComponentFormTemplatesRegistration | ComponentFormTemplatesReview | ComponentFormsForm | ComponentLinksProductLinks | ComponentLinksSocialLinks | ComponentPagesFlowPage | ComponentUtilsModule | ComponentUtilsProductCategory | ComponentUtilsSimpleProduct | FileRelation | FlowPages | FlowPagesAggregator | FlowPagesConnection | FlowPagesConnectionAdditionalProduct | FlowPagesConnectionAllowExit | FlowPagesConnectionCreated_At | FlowPagesConnectionCtaText | FlowPagesConnectionDescription | FlowPagesConnectionDisplay | FlowPagesConnectionId | FlowPagesConnectionImage | FlowPagesConnectionLoader | FlowPagesConnectionLocale | FlowPagesConnectionProduct | FlowPagesConnectionPublishedAt | FlowPagesConnectionPublished_At | FlowPagesConnectionRegistration | FlowPagesConnectionSlug | FlowPagesConnectionStatus | FlowPagesConnectionTitle | FlowPagesConnectionUid | FlowPagesConnectionUpdated_At | FlowPagesGroupBy | FormPages | FormPagesAggregator | FormPagesConnection | FormPagesConnectionCompany | FormPagesConnectionCreated_At | FormPagesConnectionCtaText | FormPagesConnectionId | FormPagesConnectionLocale | FormPagesConnectionName | FormPagesConnectionPublishedAt | FormPagesConnectionPublished_At | FormPagesConnectionSlug | FormPagesConnectionStatus | FormPagesConnectionUid | FormPagesConnectionUpdated_At | FormPagesConnectionWithCgu | FormPagesGroupBy | Forms | FormsAggregator | FormsConnection | FormsConnectionCompany | FormsConnectionCreated_At | FormsConnectionCtaText | FormsConnectionId | FormsConnectionIsProductRegistration | FormsConnectionLocale | FormsConnectionName | FormsConnectionPublishedAt | FormsConnectionPublished_At | FormsConnectionSlug | FormsConnectionStatus | FormsConnectionType | FormsConnectionUid | FormsConnectionUpdated_At | FormsConnectionWithCgu | FormsGroupBy | I18NLocale | I18NLocaleAggregator | I18NLocaleConnection | I18NLocaleConnectionCode | I18NLocaleConnectionCreated_At | I18NLocaleConnectionId | I18NLocaleConnectionName | I18NLocaleConnectionUpdated_At | I18NLocaleGroupBy | Modals | ModalsAggregator | ModalsConnection | ModalsConnectionCompany | ModalsConnectionCreated_At | ModalsConnectionFilter | ModalsConnectionId | ModalsConnectionLocale | ModalsConnectionName | ModalsConnectionPublishedAt | ModalsConnectionPublished_At | ModalsConnectionStatus | ModalsConnectionTrigger | ModalsConnectionType | ModalsConnectionUid | ModalsConnectionUpdated_At | ModalsGroupBy | Modules | ModulesAggregator | ModulesConnection | ModulesConnectionCreated_At | ModulesConnectionCtaText | ModulesConnectionDisplayType | ModulesConnectionIcon | ModulesConnectionId | ModulesConnectionImage | ModulesConnectionIsLocked | ModulesConnectionLocale | ModulesConnectionProduct | ModulesConnectionPublishedAt | ModulesConnectionPublished_At | ModulesConnectionStatus | ModulesConnectionSubtitle | ModulesConnectionTitle | ModulesConnectionType | ModulesConnectionUid | ModulesConnectionUpdated_At | ModulesGroupBy | Nodes | NodesAggregator | NodesAggregatorAvg | NodesAggregatorMax | NodesAggregatorMin | NodesAggregatorSum | NodesConnection | NodesConnectionArticle | NodesConnectionCreated_At | NodesConnectionId | NodesConnectionLocale | NodesConnectionMedia | NodesConnectionNodeId | NodesConnectionOrder | NodesConnectionParent | NodesConnectionProperties | NodesConnectionPublishedAt | NodesConnectionPublished_At | NodesConnectionStatus | NodesConnectionType | NodesConnectionUid | NodesConnectionUpdated_At | NodesGroupBy | PageInfo | Price | Products | ProductsAggregator | ProductsConnection | ProductsConnectionCharacteristics | ProductsConnectionCompany | ProductsConnectionCreated_At | ProductsConnectionCrmId | ProductsConnectionId | ProductsConnectionLocale | ProductsConnectionName | ProductsConnectionOnboarding | ProductsConnectionProductDisplayType | ProductsConnectionProductLogo | ProductsConnectionPublishedAt | ProductsConnectionPublished_At | ProductsConnectionSlug | ProductsConnectionStatus | ProductsConnectionSubtitle | ProductsConnectionUid | ProductsConnectionUpdated_At | ProductsGroupBy | Stories | StoriesAggregator | StoriesConnection | StoriesConnectionConfig | StoriesConnectionCreated_At | StoriesConnectionId | StoriesConnectionLocale | StoriesConnectionPreviewImage | StoriesConnectionPublishedAt | StoriesConnectionPublished_At | StoriesConnectionSlug | StoriesConnectionStatus | StoriesConnectionTags | StoriesConnectionTitle | StoriesConnectionUid | StoriesConnectionUpdated_At | StoriesGroupBy | StoryPages | StoryPagesAggregator | StoryPagesAggregatorAvg | StoryPagesAggregatorMax | StoryPagesAggregatorMin | StoryPagesAggregatorSum | StoryPagesConnection | StoryPagesConnectionCreated_At | StoryPagesConnectionDisplayText | StoryPagesConnectionId | StoryPagesConnectionLocale | StoryPagesConnectionLooping | StoryPagesConnectionMedia | StoryPagesConnectionOrder | StoryPagesConnectionPublished_At | StoryPagesConnectionSlug | StoryPagesConnectionStory | StoryPagesConnectionTitle | StoryPagesConnectionUid | StoryPagesConnectionUpdated_At | StoryPagesGroupBy | TextAnswers | TextAnswersAggregator | TextAnswersConnection | TextAnswersConnectionAnswer | TextAnswersConnectionCreated_At | TextAnswersConnectionId | TextAnswersConnectionLocale | TextAnswersConnectionPublishedAt | TextAnswersConnectionPublished_At | TextAnswersConnectionSlug | TextAnswersConnectionStatus | TextAnswersConnectionTagsArray | TextAnswersConnectionTitle | TextAnswersConnectionUid | TextAnswersConnectionUpdated_At | TextAnswersGroupBy | Themes | ThemesAggregator | ThemesConnection | ThemesConnectionAdditional_Product_Background_Color | ThemesConnectionAdditional_Product_Cta_Background_Color | ThemesConnectionAdditional_Product_Cta_Font_Color | ThemesConnectionAdditional_Product_Font_Color | ThemesConnectionCompany_Title_Color | ThemesConnectionCreated_At | ThemesConnectionHomepage_Picture | ThemesConnectionHomepage_Section_Title_Color | ThemesConnectionId | ThemesConnectionInformation_Cta_Color | ThemesConnectionModal_Banner_Background_Color | ThemesConnectionModal_Picture | ThemesConnectionModal_Picture_Background_Color | ThemesConnectionProduct_Page_Cta_Background_Color | ThemesConnectionProduct_Page_Cta_Font_Color | ThemesConnectionProduct_Title_Color | ThemesConnectionPublishedAt | ThemesConnectionPublished_At | ThemesConnectionReview_Cta_Background_Color | ThemesConnectionReview_Cta_Font_Color | ThemesConnectionReview_Modal_Cta_Color | ThemesConnectionSocial_Button_Background_Color | ThemesConnectionSocial_Button_Icon_Color | ThemesConnectionStatus | ThemesConnectionStory_Cta_Background_Color | ThemesConnectionStory_Cta_Font_Color | ThemesConnectionStory_Title_Font_Color | ThemesConnectionUid | ThemesConnectionUpdated_At | ThemesGroupBy | UploadFile | UploadFileAggregator | UploadFileAggregatorAvg | UploadFileAggregatorMax | UploadFileAggregatorMin | UploadFileAggregatorSum | UploadFileConnection | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionCreated_At | UploadFileConnectionExt | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionHeight | UploadFileConnectionId | UploadFileConnectionMime | UploadFileConnectionName | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionSize | UploadFileConnectionUpdated_At | UploadFileConnectionUrl | UploadFileConnectionWidth | UploadFileGroupBy | UserPermissionsPasswordPayload | UsersPermissionsLoginPayload | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleAggregator | UsersPermissionsRoleConnection | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionType | UsersPermissionsRoleGroupBy | UsersPermissionsUser | UsersPermissionsUserAggregator | UsersPermissionsUserConnection | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserGroupBy | VariantOption | Variants | VariantsAggregator | VariantsConnection | VariantsConnectionAvailability | VariantsConnectionCreated_At | VariantsConnectionExternalId | VariantsConnectionGtin | VariantsConnectionId | VariantsConnectionImageUrl | VariantsConnectionLocale | VariantsConnectionName | VariantsConnectionProduct | VariantsConnectionSource | VariantsConnectionUpdated_At | VariantsConnectionUrl | VariantsGroupBy | CreateAdditionalProductPayload | CreateArticlePayload | CreateCompanyPayload | CreateFlowPagePayload | CreateFormPagePayload | CreateFormPayload | CreateModalPayload | CreateModulePayload | CreateNodePayload | CreateProductPayload | CreateRolePayload | CreateStoryPagePayload | CreateStoryPayload | CreateTextAnswerPayload | CreateThemePayload | CreateUserPayload | CreateVariantPayload | DeleteAdditionalProductPayload | DeleteArticlePayload | DeleteCompanyPayload | DeleteFilePayload | DeleteFlowPagePayload | DeleteFormPagePayload | DeleteFormPayload | DeleteModalPayload | DeleteModulePayload | DeleteNodePayload | DeleteProductPayload | DeleteRolePayload | DeleteStoryPagePayload | DeleteStoryPayload | DeleteTextAnswerPayload | DeleteThemePayload | DeleteUserPayload | DeleteVariantPayload | UpdateAdditionalProductPayload | UpdateArticlePayload | UpdateCompanyPayload | UpdateFlowPagePayload | UpdateFormPagePayload | UpdateFormPayload | UpdateModalPayload | UpdateModulePayload | UpdateNodePayload | UpdateProductPayload | UpdateRolePayload | UpdateStoryPagePayload | UpdateStoryPayload | UpdateTextAnswerPayload | UpdateThemePayload | UpdateUserPayload | UpdateVariantPayload | UpdateVariantsPayload;

export type Mutation = {
  __typename?: 'Mutation';
  createAdditionalProduct?: Maybe<CreateAdditionalProductPayload>;
  createAdditionalProductLocalization: AdditionalProducts;
  createArticle?: Maybe<CreateArticlePayload>;
  createArticleLocalization: Articles;
  createCompany?: Maybe<CreateCompanyPayload>;
  createCompanyLocalization: Companies;
  createFlowPage?: Maybe<CreateFlowPagePayload>;
  createFlowPageLocalization: FlowPages;
  createForm?: Maybe<CreateFormPayload>;
  createFormLocalization: Forms;
  createFormPage?: Maybe<CreateFormPagePayload>;
  createFormPageLocalization: FormPages;
  createModal?: Maybe<CreateModalPayload>;
  createModalLocalization: Modals;
  createModule?: Maybe<CreateModulePayload>;
  createModuleLocalization: Modules;
  createNode?: Maybe<CreateNodePayload>;
  createNodeLocalization: Nodes;
  createProduct?: Maybe<CreateProductPayload>;
  createProductLocalization: Products;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  createStory?: Maybe<CreateStoryPayload>;
  createStoryLocalization: Stories;
  createStoryPage?: Maybe<CreateStoryPagePayload>;
  createStoryPageLocalization: StoryPages;
  createTextAnswer?: Maybe<CreateTextAnswerPayload>;
  createTextAnswerLocalization: TextAnswers;
  createTheme?: Maybe<CreateThemePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  createVariant?: Maybe<CreateVariantPayload>;
  createVariantLocalization: Variants;
  deleteAdditionalProduct?: Maybe<DeleteAdditionalProductPayload>;
  deleteAdditionalProductAndLocalizations?: Maybe<DeleteAdditionalProductPayload>;
  deleteArticle?: Maybe<DeleteArticlePayload>;
  deleteCompany?: Maybe<DeleteCompanyPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  deleteFlowPage?: Maybe<DeleteFlowPagePayload>;
  deleteForm?: Maybe<DeleteFormPayload>;
  deleteFormPage?: Maybe<DeleteFormPagePayload>;
  deleteModal?: Maybe<DeleteModalPayload>;
  deleteModule?: Maybe<DeleteModulePayload>;
  deleteNode?: Maybe<DeleteNodePayload>;
  deleteProduct?: Maybe<DeleteProductPayload>;
  deleteProductAndLocalizations?: Maybe<DeleteProductPayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteStory?: Maybe<DeleteStoryPayload>;
  deleteStoryPage?: Maybe<DeleteStoryPagePayload>;
  deleteTextAnswer?: Maybe<DeleteTextAnswerPayload>;
  deleteTheme?: Maybe<DeleteThemePayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteVariant?: Maybe<DeleteVariantPayload>;
  duplicateAdditionalProduct: AdditionalProducts;
  duplicateArticle: Articles;
  duplicateCompany: Companies;
  duplicateModule: Modules;
  duplicateProduct: Products;
  duplicateStory: Stories;
  editorCreate: Nodes;
  editorDelete: Nodes;
  editorUpdate: Nodes;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  moveAdditionalProduct: AdditionalProducts;
  moveArticle: Articles;
  moveModule: Modules;
  moveProduct: Products;
  moveStory: Stories;
  moveStoryPage: StoryPages;
  multipleUpload: Array<Maybe<UploadFile>>;
  register: UsersPermissionsLoginPayload;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  unsetFileRelation: Scalars['Boolean']['output'];
  updateAdditionalProduct?: Maybe<UpdateAdditionalProductPayload>;
  updateArticle?: Maybe<UpdateArticlePayload>;
  updateCompany?: Maybe<UpdateCompanyPayload>;
  updateFileInfo: UploadFile;
  updateFlowPage?: Maybe<UpdateFlowPagePayload>;
  updateForm?: Maybe<UpdateFormPayload>;
  updateFormPage?: Maybe<UpdateFormPagePayload>;
  updateModal?: Maybe<UpdateModalPayload>;
  updateModule?: Maybe<UpdateModulePayload>;
  updateNode?: Maybe<UpdateNodePayload>;
  updateProduct?: Maybe<UpdateProductPayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  updateStory?: Maybe<UpdateStoryPayload>;
  updateStoryPage?: Maybe<UpdateStoryPagePayload>;
  updateTextAnswer?: Maybe<UpdateTextAnswerPayload>;
  updateTheme?: Maybe<UpdateThemePayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  updateVariant?: Maybe<UpdateVariantPayload>;
  updateVariants?: Maybe<UpdateVariantsPayload>;
  upload: UploadFile;
};


export type MutationCreateAdditionalProductArgs = {
  input?: InputMaybe<CreateAdditionalProductInput>;
};


export type MutationCreateAdditionalProductLocalizationArgs = {
  input: UpdateAdditionalProductInput;
};


export type MutationCreateArticleArgs = {
  input?: InputMaybe<CreateArticleInput>;
};


export type MutationCreateArticleLocalizationArgs = {
  input: UpdateArticleInput;
};


export type MutationCreateCompanyArgs = {
  input?: InputMaybe<CreateCompanyInput>;
};


export type MutationCreateCompanyLocalizationArgs = {
  input: UpdateCompanyInput;
};


export type MutationCreateFlowPageArgs = {
  input?: InputMaybe<CreateFlowPageInput>;
};


export type MutationCreateFlowPageLocalizationArgs = {
  input: UpdateFlowPageInput;
};


export type MutationCreateFormArgs = {
  input?: InputMaybe<CreateFormInput>;
};


export type MutationCreateFormLocalizationArgs = {
  input: UpdateFormInput;
};


export type MutationCreateFormPageArgs = {
  input?: InputMaybe<CreateFormPageInput>;
};


export type MutationCreateFormPageLocalizationArgs = {
  input: UpdateFormPageInput;
};


export type MutationCreateModalArgs = {
  input?: InputMaybe<CreateModalInput>;
};


export type MutationCreateModalLocalizationArgs = {
  input: UpdateModalInput;
};


export type MutationCreateModuleArgs = {
  input?: InputMaybe<CreateModuleInput>;
};


export type MutationCreateModuleLocalizationArgs = {
  input: UpdateModuleInput;
};


export type MutationCreateNodeArgs = {
  input?: InputMaybe<CreateNodeInput>;
};


export type MutationCreateNodeLocalizationArgs = {
  input: UpdateNodeInput;
};


export type MutationCreateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationCreateProductLocalizationArgs = {
  input: UpdateProductInput;
};


export type MutationCreateRoleArgs = {
  input?: InputMaybe<CreateRoleInput>;
};


export type MutationCreateStoryArgs = {
  input?: InputMaybe<CreateStoryInput>;
};


export type MutationCreateStoryLocalizationArgs = {
  input: UpdateStoryInput;
};


export type MutationCreateStoryPageArgs = {
  input?: InputMaybe<CreateStoryPageInput>;
};


export type MutationCreateStoryPageLocalizationArgs = {
  input: UpdateStoryPageInput;
};


export type MutationCreateTextAnswerArgs = {
  input?: InputMaybe<CreateTextAnswerInput>;
};


export type MutationCreateTextAnswerLocalizationArgs = {
  input: UpdateTextAnswerInput;
};


export type MutationCreateThemeArgs = {
  input?: InputMaybe<CreateThemeInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationCreateVariantArgs = {
  input?: InputMaybe<CreateVariantInput>;
};


export type MutationCreateVariantLocalizationArgs = {
  input: UpdateVariantInput;
};


export type MutationDeleteAdditionalProductArgs = {
  input?: InputMaybe<DeleteAdditionalProductInput>;
};


export type MutationDeleteAdditionalProductAndLocalizationsArgs = {
  input?: InputMaybe<DeleteAdditionalProductInput>;
};


export type MutationDeleteArticleArgs = {
  input?: InputMaybe<DeleteArticleInput>;
};


export type MutationDeleteCompanyArgs = {
  input?: InputMaybe<DeleteCompanyInput>;
};


export type MutationDeleteFileArgs = {
  input?: InputMaybe<DeleteFileInput>;
};


export type MutationDeleteFlowPageArgs = {
  input?: InputMaybe<DeleteFlowPageInput>;
};


export type MutationDeleteFormArgs = {
  input?: InputMaybe<DeleteFormInput>;
};


export type MutationDeleteFormPageArgs = {
  input?: InputMaybe<DeleteFormPageInput>;
};


export type MutationDeleteModalArgs = {
  input?: InputMaybe<DeleteModalInput>;
};


export type MutationDeleteModuleArgs = {
  input?: InputMaybe<DeleteModuleInput>;
};


export type MutationDeleteNodeArgs = {
  input?: InputMaybe<DeleteNodeInput>;
};


export type MutationDeleteProductArgs = {
  input?: InputMaybe<DeleteProductInput>;
};


export type MutationDeleteProductAndLocalizationsArgs = {
  input?: InputMaybe<DeleteProductInput>;
};


export type MutationDeleteRoleArgs = {
  input?: InputMaybe<DeleteRoleInput>;
};


export type MutationDeleteStoryArgs = {
  input?: InputMaybe<DeleteStoryInput>;
};


export type MutationDeleteStoryPageArgs = {
  input?: InputMaybe<DeleteStoryPageInput>;
};


export type MutationDeleteTextAnswerArgs = {
  input?: InputMaybe<DeleteTextAnswerInput>;
};


export type MutationDeleteThemeArgs = {
  input?: InputMaybe<DeleteThemeInput>;
};


export type MutationDeleteUserArgs = {
  input?: InputMaybe<DeleteUserInput>;
};


export type MutationDeleteVariantArgs = {
  input?: InputMaybe<DeleteVariantInput>;
};


export type MutationDuplicateAdditionalProductArgs = {
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  duplicateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateArticleArgs = {
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  duplicateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateCompanyArgs = {
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  duplicateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateModuleArgs = {
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  duplicateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateProductArgs = {
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  duplicateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateStoryArgs = {
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  duplicateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEditorCreateArgs = {
  Article?: InputMaybe<Scalars['ID']['input']>;
  NodeID: Scalars['ID']['input'];
  Order?: InputMaybe<Scalars['Int']['input']>;
  Parent?: InputMaybe<Scalars['ID']['input']>;
  Properties?: InputMaybe<Scalars['JSON']['input']>;
  Type: Enum_Nodes_Type;
};


export type MutationEditorDeleteArgs = {
  NodeID: Scalars['ID']['input'];
};


export type MutationEditorUpdateArgs = {
  Article?: InputMaybe<Scalars['ID']['input']>;
  NodeID: Scalars['ID']['input'];
  Order?: InputMaybe<Scalars['Int']['input']>;
  Parent?: InputMaybe<Scalars['ID']['input']>;
  Properties?: InputMaybe<Scalars['JSON']['input']>;
  Type?: InputMaybe<Enum_Nodes_Type>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMoveAdditionalProductArgs = {
  accessors?: InputMaybe<Array<Accessor>>;
  destinationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationMoveArticleArgs = {
  accessors?: InputMaybe<Array<Accessor>>;
  destinationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationMoveModuleArgs = {
  accessors?: InputMaybe<Array<Accessor>>;
  destinationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationMoveProductArgs = {
  accessors?: InputMaybe<Array<Accessor>>;
  destinationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationMoveStoryArgs = {
  accessors?: InputMaybe<Array<Accessor>>;
  destinationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationMoveStoryPageArgs = {
  accessors?: InputMaybe<Array<Accessor>>;
  destinationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUnsetFileRelationArgs = {
  field: Scalars['String']['input'];
  fileId: Scalars['ID']['input'];
  ref: Scalars['String']['input'];
  refId: Scalars['ID']['input'];
};


export type MutationUpdateAdditionalProductArgs = {
  input?: InputMaybe<UpdateAdditionalProductInput>;
};


export type MutationUpdateArticleArgs = {
  input?: InputMaybe<UpdateArticleInput>;
};


export type MutationUpdateCompanyArgs = {
  input?: InputMaybe<UpdateCompanyInput>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info: FileInfoInput;
};


export type MutationUpdateFlowPageArgs = {
  input?: InputMaybe<UpdateFlowPageInput>;
};


export type MutationUpdateFormArgs = {
  input?: InputMaybe<UpdateFormInput>;
};


export type MutationUpdateFormPageArgs = {
  input?: InputMaybe<UpdateFormPageInput>;
};


export type MutationUpdateModalArgs = {
  input?: InputMaybe<UpdateModalInput>;
};


export type MutationUpdateModuleArgs = {
  input?: InputMaybe<UpdateModuleInput>;
};


export type MutationUpdateNodeArgs = {
  input?: InputMaybe<UpdateNodeInput>;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<UpdateProductInput>;
};


export type MutationUpdateRoleArgs = {
  input?: InputMaybe<UpdateRoleInput>;
};


export type MutationUpdateStoryArgs = {
  input?: InputMaybe<UpdateStoryInput>;
};


export type MutationUpdateStoryPageArgs = {
  input?: InputMaybe<UpdateStoryPageInput>;
};


export type MutationUpdateTextAnswerArgs = {
  input?: InputMaybe<UpdateTextAnswerInput>;
};


export type MutationUpdateThemeArgs = {
  input?: InputMaybe<UpdateThemeInput>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateVariantArgs = {
  input?: InputMaybe<UpdateVariantInput>;
};


export type MutationUpdateVariantsArgs = {
  input: UpdateVariantsInput;
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type NodeInput = {
  Article?: InputMaybe<Scalars['ID']['input']>;
  Children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Media?: InputMaybe<Scalars['ID']['input']>;
  NodeID: Scalars['String']['input'];
  Order: Scalars['Int']['input'];
  Parent?: InputMaybe<Scalars['ID']['input']>;
  Properties?: InputMaybe<Scalars['JSON']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Type: Enum_Nodes_Type;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Nodes = {
  __typename?: 'Nodes';
  Article?: Maybe<Articles>;
  Children?: Maybe<Array<Maybe<Nodes>>>;
  Media?: Maybe<UploadFile>;
  NodeID: Scalars['String']['output'];
  Order: Scalars['Int']['output'];
  Parent?: Maybe<Nodes>;
  Properties?: Maybe<Scalars['JSON']['output']>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Type: Enum_Nodes_Type;
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Nodes>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type NodesChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type NodesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type NodesAggregator = {
  __typename?: 'NodesAggregator';
  avg?: Maybe<NodesAggregatorAvg>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<NodesAggregatorMax>;
  min?: Maybe<NodesAggregatorMin>;
  sum?: Maybe<NodesAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NodesAggregatorAvg = {
  __typename?: 'NodesAggregatorAvg';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type NodesAggregatorMax = {
  __typename?: 'NodesAggregatorMax';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type NodesAggregatorMin = {
  __typename?: 'NodesAggregatorMin';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type NodesAggregatorSum = {
  __typename?: 'NodesAggregatorSum';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type NodesConnection = {
  __typename?: 'NodesConnection';
  aggregate?: Maybe<NodesAggregator>;
  groupBy?: Maybe<NodesGroupBy>;
  values?: Maybe<Array<Maybe<Nodes>>>;
};

export type NodesConnectionArticle = {
  __typename?: 'NodesConnectionArticle';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type NodesConnectionCreated_At = {
  __typename?: 'NodesConnectionCreated_at';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type NodesConnectionId = {
  __typename?: 'NodesConnectionId';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type NodesConnectionLocale = {
  __typename?: 'NodesConnectionLocale';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type NodesConnectionMedia = {
  __typename?: 'NodesConnectionMedia';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type NodesConnectionNodeId = {
  __typename?: 'NodesConnectionNodeID';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type NodesConnectionOrder = {
  __typename?: 'NodesConnectionOrder';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['Int']['output']>;
};

export type NodesConnectionParent = {
  __typename?: 'NodesConnectionParent';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type NodesConnectionProperties = {
  __typename?: 'NodesConnectionProperties';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type NodesConnectionPublishedAt = {
  __typename?: 'NodesConnectionPublishedAt';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type NodesConnectionPublished_At = {
  __typename?: 'NodesConnectionPublished_at';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type NodesConnectionStatus = {
  __typename?: 'NodesConnectionStatus';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type NodesConnectionType = {
  __typename?: 'NodesConnectionType';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type NodesConnectionUid = {
  __typename?: 'NodesConnectionUID';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type NodesConnectionUpdated_At = {
  __typename?: 'NodesConnectionUpdated_at';
  connection?: Maybe<NodesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type NodesGroupBy = {
  __typename?: 'NodesGroupBy';
  Article?: Maybe<Array<Maybe<NodesConnectionArticle>>>;
  Media?: Maybe<Array<Maybe<NodesConnectionMedia>>>;
  NodeID?: Maybe<Array<Maybe<NodesConnectionNodeId>>>;
  Order?: Maybe<Array<Maybe<NodesConnectionOrder>>>;
  Parent?: Maybe<Array<Maybe<NodesConnectionParent>>>;
  Properties?: Maybe<Array<Maybe<NodesConnectionProperties>>>;
  PublishedAt?: Maybe<Array<Maybe<NodesConnectionPublishedAt>>>;
  Status?: Maybe<Array<Maybe<NodesConnectionStatus>>>;
  Type?: Maybe<Array<Maybe<NodesConnectionType>>>;
  UID?: Maybe<Array<Maybe<NodesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<NodesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<NodesConnectionId>>>;
  locale?: Maybe<Array<Maybe<NodesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<NodesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<NodesConnectionUpdated_At>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type PriceInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type ProductInput = {
  Articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Characteristics?: InputMaybe<Scalars['JSON']['input']>;
  Company?: InputMaybe<Scalars['ID']['input']>;
  CrmId?: InputMaybe<Scalars['String']['input']>;
  FlowPages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Image?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ModuleList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Modules?: InputMaybe<Array<InputMaybe<ComponentUtilsModuleInput>>>;
  Name: Scalars['String']['input'];
  Onboarding?: InputMaybe<Scalars['ID']['input']>;
  ProductDisplayType?: InputMaybe<Enum_Products_Productdisplaytype>;
  ProductLinks?: InputMaybe<Array<InputMaybe<ComponentLinksProductLinkInput>>>;
  ProductLogo?: InputMaybe<Scalars['ID']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Stories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Subtitle?: InputMaybe<Scalars['String']['input']>;
  Text_answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Products = {
  __typename?: 'Products';
  Articles?: Maybe<Array<Maybe<Articles>>>;
  Characteristics?: Maybe<Scalars['JSON']['output']>;
  Company?: Maybe<Companies>;
  CrmId?: Maybe<Scalars['String']['output']>;
  FlowPages?: Maybe<Array<Maybe<FlowPages>>>;
  Image?: Maybe<Array<Maybe<UploadFile>>>;
  ModuleList?: Maybe<Array<Maybe<Modules>>>;
  Modules?: Maybe<Array<Maybe<ComponentUtilsModule>>>;
  Name: Scalars['String']['output'];
  Onboarding?: Maybe<Modules>;
  ProductDisplayType: Enum_Products_Productdisplaytype;
  ProductLinks?: Maybe<Array<Maybe<ComponentLinksProductLinks>>>;
  ProductLogo?: Maybe<UploadFile>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Stories?: Maybe<Array<Maybe<Stories>>>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Text_answers?: Maybe<Array<Maybe<TextAnswers>>>;
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Products>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type ProductsArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProductsFlowPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProductsImageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProductsModuleListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProductsStoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProductsText_AnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProductsLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsAggregator = {
  __typename?: 'ProductsAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductsConnection = {
  __typename?: 'ProductsConnection';
  aggregate?: Maybe<ProductsAggregator>;
  groupBy?: Maybe<ProductsGroupBy>;
  values?: Maybe<Array<Maybe<Products>>>;
};

export type ProductsConnectionCharacteristics = {
  __typename?: 'ProductsConnectionCharacteristics';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type ProductsConnectionCompany = {
  __typename?: 'ProductsConnectionCompany';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ProductsConnectionCreated_At = {
  __typename?: 'ProductsConnectionCreated_at';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductsConnectionCrmId = {
  __typename?: 'ProductsConnectionCrmId';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionId = {
  __typename?: 'ProductsConnectionId';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ProductsConnectionLocale = {
  __typename?: 'ProductsConnectionLocale';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionName = {
  __typename?: 'ProductsConnectionName';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionOnboarding = {
  __typename?: 'ProductsConnectionOnboarding';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ProductsConnectionProductDisplayType = {
  __typename?: 'ProductsConnectionProductDisplayType';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionProductLogo = {
  __typename?: 'ProductsConnectionProductLogo';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ProductsConnectionPublishedAt = {
  __typename?: 'ProductsConnectionPublishedAt';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductsConnectionPublished_At = {
  __typename?: 'ProductsConnectionPublished_at';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductsConnectionSlug = {
  __typename?: 'ProductsConnectionSlug';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionStatus = {
  __typename?: 'ProductsConnectionStatus';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionSubtitle = {
  __typename?: 'ProductsConnectionSubtitle';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionUid = {
  __typename?: 'ProductsConnectionUID';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ProductsConnectionUpdated_At = {
  __typename?: 'ProductsConnectionUpdated_at';
  connection?: Maybe<ProductsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductsGroupBy = {
  __typename?: 'ProductsGroupBy';
  Characteristics?: Maybe<Array<Maybe<ProductsConnectionCharacteristics>>>;
  Company?: Maybe<Array<Maybe<ProductsConnectionCompany>>>;
  CrmId?: Maybe<Array<Maybe<ProductsConnectionCrmId>>>;
  Name?: Maybe<Array<Maybe<ProductsConnectionName>>>;
  Onboarding?: Maybe<Array<Maybe<ProductsConnectionOnboarding>>>;
  ProductDisplayType?: Maybe<Array<Maybe<ProductsConnectionProductDisplayType>>>;
  ProductLogo?: Maybe<Array<Maybe<ProductsConnectionProductLogo>>>;
  PublishedAt?: Maybe<Array<Maybe<ProductsConnectionPublishedAt>>>;
  Slug?: Maybe<Array<Maybe<ProductsConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<ProductsConnectionStatus>>>;
  Subtitle?: Maybe<Array<Maybe<ProductsConnectionSubtitle>>>;
  UID?: Maybe<Array<Maybe<ProductsConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<ProductsConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ProductsConnectionId>>>;
  locale?: Maybe<Array<Maybe<ProductsConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<ProductsConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<ProductsConnectionUpdated_At>>>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  additionalProduct?: Maybe<AdditionalProducts>;
  additionalProducts?: Maybe<Array<Maybe<AdditionalProducts>>>;
  additionalProductsConnection?: Maybe<AdditionalProductsConnection>;
  article?: Maybe<Articles>;
  articles?: Maybe<Array<Maybe<Articles>>>;
  articlesConnection?: Maybe<ArticlesConnection>;
  companies?: Maybe<Array<Maybe<Companies>>>;
  companiesConnection?: Maybe<CompaniesConnection>;
  company?: Maybe<Companies>;
  companyMediaLibrary?: Maybe<CompanyMediaLibraryResponse>;
  compareRawStateAndBuiltState?: Maybe<Compare>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  flowPage?: Maybe<FlowPages>;
  flowPages?: Maybe<Array<Maybe<FlowPages>>>;
  flowPagesConnection?: Maybe<FlowPagesConnection>;
  form?: Maybe<Forms>;
  formPage?: Maybe<FormPages>;
  formPages?: Maybe<Array<Maybe<FormPages>>>;
  formPagesConnection?: Maybe<FormPagesConnection>;
  forms?: Maybe<Array<Maybe<Forms>>>;
  formsConnection?: Maybe<FormsConnection>;
  locales?: Maybe<Array<Maybe<I18NLocale>>>;
  localesConnection?: Maybe<I18NLocaleConnection>;
  me?: Maybe<UsersPermissionsMe>;
  modal?: Maybe<Modals>;
  modals?: Maybe<Array<Maybe<Modals>>>;
  modalsConnection?: Maybe<ModalsConnection>;
  module?: Maybe<Modules>;
  modules?: Maybe<Array<Maybe<Modules>>>;
  modulesConnection?: Maybe<ModulesConnection>;
  node?: Maybe<Nodes>;
  nodes?: Maybe<Array<Maybe<Nodes>>>;
  nodesConnection?: Maybe<NodesConnection>;
  product?: Maybe<Products>;
  products?: Maybe<Array<Maybe<Products>>>;
  productsConnection?: Maybe<ProductsConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  stories?: Maybe<Array<Maybe<Stories>>>;
  storiesConnection?: Maybe<StoriesConnection>;
  story?: Maybe<Stories>;
  storyPage?: Maybe<StoryPages>;
  storyPages?: Maybe<Array<Maybe<StoryPages>>>;
  storyPagesConnection?: Maybe<StoryPagesConnection>;
  textAnswer?: Maybe<TextAnswers>;
  textAnswers?: Maybe<Array<Maybe<TextAnswers>>>;
  textAnswersConnection?: Maybe<TextAnswersConnection>;
  theme?: Maybe<Themes>;
  themes?: Maybe<Array<Maybe<Themes>>>;
  themesConnection?: Maybe<ThemesConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  variant?: Maybe<Variants>;
  variants?: Maybe<Array<Maybe<Variants>>>;
  variantsConnection?: Maybe<VariantsConnection>;
};


export type QueryAdditionalProductArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryAdditionalProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryAdditionalProductsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryArticleArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryArticlesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCompaniesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCompanyMediaLibraryArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCompareRawStateAndBuiltStateArgs = {
  articleId: Scalars['ID']['input'];
};


export type QueryFilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFilesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFlowPageArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFlowPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFlowPagesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFormArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFormPageArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFormPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFormPagesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFormsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFormsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryLocalesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryLocalesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryModalArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryModalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryModalsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryModuleArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryModulesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryNodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryNodesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryProductsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRolesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryStoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryStoriesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryStoryArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryStoryPageArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryStoryPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryStoryPagesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryTextAnswerArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTextAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryTextAnswersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryThemeArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryThemesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryThemesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUsersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryVariantArgs = {
  id: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryVariantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryVariantsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export enum RedirectionType {
  Inside = 'inside',
  Outside = 'outside'
}

export type RoleInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum SingleSelectDisplayType {
  Dropdown = 'dropdown',
  RadioCard = 'radioCard'
}

export type Stories = {
  __typename?: 'Stories';
  Config?: Maybe<Scalars['JSON']['output']>;
  PreviewImage?: Maybe<UploadFile>;
  Products?: Maybe<Array<Maybe<Products>>>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StoryPages?: Maybe<Array<Maybe<StoryPages>>>;
  Tags?: Maybe<Scalars['JSON']['output']>;
  Title: Scalars['String']['output'];
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Stories>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type StoriesProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type StoriesStoryPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type StoriesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type StoriesAggregator = {
  __typename?: 'StoriesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StoriesConnection = {
  __typename?: 'StoriesConnection';
  aggregate?: Maybe<StoriesAggregator>;
  groupBy?: Maybe<StoriesGroupBy>;
  values?: Maybe<Array<Maybe<Stories>>>;
};

export type StoriesConnectionConfig = {
  __typename?: 'StoriesConnectionConfig';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type StoriesConnectionCreated_At = {
  __typename?: 'StoriesConnectionCreated_at';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoriesConnectionId = {
  __typename?: 'StoriesConnectionId';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type StoriesConnectionLocale = {
  __typename?: 'StoriesConnectionLocale';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoriesConnectionPreviewImage = {
  __typename?: 'StoriesConnectionPreviewImage';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type StoriesConnectionPublishedAt = {
  __typename?: 'StoriesConnectionPublishedAt';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoriesConnectionPublished_At = {
  __typename?: 'StoriesConnectionPublished_at';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoriesConnectionSlug = {
  __typename?: 'StoriesConnectionSlug';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoriesConnectionStatus = {
  __typename?: 'StoriesConnectionStatus';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoriesConnectionTags = {
  __typename?: 'StoriesConnectionTags';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type StoriesConnectionTitle = {
  __typename?: 'StoriesConnectionTitle';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoriesConnectionUid = {
  __typename?: 'StoriesConnectionUID';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoriesConnectionUpdated_At = {
  __typename?: 'StoriesConnectionUpdated_at';
  connection?: Maybe<StoriesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoriesGroupBy = {
  __typename?: 'StoriesGroupBy';
  Config?: Maybe<Array<Maybe<StoriesConnectionConfig>>>;
  PreviewImage?: Maybe<Array<Maybe<StoriesConnectionPreviewImage>>>;
  PublishedAt?: Maybe<Array<Maybe<StoriesConnectionPublishedAt>>>;
  Slug?: Maybe<Array<Maybe<StoriesConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<StoriesConnectionStatus>>>;
  Tags?: Maybe<Array<Maybe<StoriesConnectionTags>>>;
  Title?: Maybe<Array<Maybe<StoriesConnectionTitle>>>;
  UID?: Maybe<Array<Maybe<StoriesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<StoriesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<StoriesConnectionId>>>;
  locale?: Maybe<Array<Maybe<StoriesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<StoriesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<StoriesConnectionUpdated_At>>>;
};

export type StoryInput = {
  Config?: InputMaybe<Scalars['JSON']['input']>;
  PreviewImage?: InputMaybe<Scalars['ID']['input']>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  StoryPages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Tags?: InputMaybe<Scalars['JSON']['input']>;
  Title: Scalars['String']['input'];
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type StoryPageInput = {
  CallToAction?: InputMaybe<Array<Scalars['StoryPagesCallToActionDynamicZoneInput']['input']>>;
  DisplayText?: InputMaybe<Scalars['String']['input']>;
  Looping?: InputMaybe<Scalars['Boolean']['input']>;
  Media?: InputMaybe<Scalars['ID']['input']>;
  Order?: InputMaybe<Scalars['Int']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Story?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type StoryPages = {
  __typename?: 'StoryPages';
  CallToAction?: Maybe<Array<Maybe<StoryPagesCallToActionDynamicZone>>>;
  DisplayText?: Maybe<Scalars['String']['output']>;
  Looping?: Maybe<Scalars['Boolean']['output']>;
  Media?: Maybe<UploadFile>;
  Order?: Maybe<Scalars['Int']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Story?: Maybe<Stories>;
  Title?: Maybe<Scalars['String']['output']>;
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<StoryPages>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type StoryPagesLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type StoryPagesAggregator = {
  __typename?: 'StoryPagesAggregator';
  avg?: Maybe<StoryPagesAggregatorAvg>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<StoryPagesAggregatorMax>;
  min?: Maybe<StoryPagesAggregatorMin>;
  sum?: Maybe<StoryPagesAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StoryPagesAggregatorAvg = {
  __typename?: 'StoryPagesAggregatorAvg';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type StoryPagesAggregatorMax = {
  __typename?: 'StoryPagesAggregatorMax';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type StoryPagesAggregatorMin = {
  __typename?: 'StoryPagesAggregatorMin';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type StoryPagesAggregatorSum = {
  __typename?: 'StoryPagesAggregatorSum';
  Order?: Maybe<Scalars['Float']['output']>;
};

export type StoryPagesCallToActionDynamicZone = ComponentContentAdditionalProduct | ComponentCtaEventCallToAction | ComponentCtaLinkCallToAction;

export type StoryPagesConnection = {
  __typename?: 'StoryPagesConnection';
  aggregate?: Maybe<StoryPagesAggregator>;
  groupBy?: Maybe<StoryPagesGroupBy>;
  values?: Maybe<Array<Maybe<StoryPages>>>;
};

export type StoryPagesConnectionCreated_At = {
  __typename?: 'StoryPagesConnectionCreated_at';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoryPagesConnectionDisplayText = {
  __typename?: 'StoryPagesConnectionDisplayText';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoryPagesConnectionId = {
  __typename?: 'StoryPagesConnectionId';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type StoryPagesConnectionLocale = {
  __typename?: 'StoryPagesConnectionLocale';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoryPagesConnectionLooping = {
  __typename?: 'StoryPagesConnectionLooping';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type StoryPagesConnectionMedia = {
  __typename?: 'StoryPagesConnectionMedia';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type StoryPagesConnectionOrder = {
  __typename?: 'StoryPagesConnectionOrder';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['Int']['output']>;
};

export type StoryPagesConnectionPublished_At = {
  __typename?: 'StoryPagesConnectionPublished_at';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoryPagesConnectionSlug = {
  __typename?: 'StoryPagesConnectionSlug';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoryPagesConnectionStory = {
  __typename?: 'StoryPagesConnectionStory';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type StoryPagesConnectionTitle = {
  __typename?: 'StoryPagesConnectionTitle';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoryPagesConnectionUid = {
  __typename?: 'StoryPagesConnectionUID';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type StoryPagesConnectionUpdated_At = {
  __typename?: 'StoryPagesConnectionUpdated_at';
  connection?: Maybe<StoryPagesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type StoryPagesGroupBy = {
  __typename?: 'StoryPagesGroupBy';
  DisplayText?: Maybe<Array<Maybe<StoryPagesConnectionDisplayText>>>;
  Looping?: Maybe<Array<Maybe<StoryPagesConnectionLooping>>>;
  Media?: Maybe<Array<Maybe<StoryPagesConnectionMedia>>>;
  Order?: Maybe<Array<Maybe<StoryPagesConnectionOrder>>>;
  Slug?: Maybe<Array<Maybe<StoryPagesConnectionSlug>>>;
  Story?: Maybe<Array<Maybe<StoryPagesConnectionStory>>>;
  Title?: Maybe<Array<Maybe<StoryPagesConnectionTitle>>>;
  UID?: Maybe<Array<Maybe<StoryPagesConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<StoryPagesConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<StoryPagesConnectionId>>>;
  locale?: Maybe<Array<Maybe<StoryPagesConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<StoryPagesConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<StoryPagesConnectionUpdated_At>>>;
};

export type TextAnswerInput = {
  Answer: Scalars['String']['input'];
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Tags?: InputMaybe<Scalars['String']['input']>;
  TagsArray?: InputMaybe<Scalars['JSON']['input']>;
  Title: Scalars['String']['input'];
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type TextAnswers = {
  __typename?: 'TextAnswers';
  Answer: Scalars['String']['output'];
  Products?: Maybe<Array<Maybe<Products>>>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  TagsArray?: Maybe<Scalars['JSON']['output']>;
  Title: Scalars['String']['output'];
  UID?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<TextAnswers>>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type TextAnswersProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type TextAnswersLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type TextAnswersAggregator = {
  __typename?: 'TextAnswersAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TextAnswersConnection = {
  __typename?: 'TextAnswersConnection';
  aggregate?: Maybe<TextAnswersAggregator>;
  groupBy?: Maybe<TextAnswersGroupBy>;
  values?: Maybe<Array<Maybe<TextAnswers>>>;
};

export type TextAnswersConnectionAnswer = {
  __typename?: 'TextAnswersConnectionAnswer';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TextAnswersConnectionCreated_At = {
  __typename?: 'TextAnswersConnectionCreated_at';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type TextAnswersConnectionId = {
  __typename?: 'TextAnswersConnectionId';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type TextAnswersConnectionLocale = {
  __typename?: 'TextAnswersConnectionLocale';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TextAnswersConnectionPublishedAt = {
  __typename?: 'TextAnswersConnectionPublishedAt';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type TextAnswersConnectionPublished_At = {
  __typename?: 'TextAnswersConnectionPublished_at';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type TextAnswersConnectionSlug = {
  __typename?: 'TextAnswersConnectionSlug';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TextAnswersConnectionStatus = {
  __typename?: 'TextAnswersConnectionStatus';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TextAnswersConnectionTagsArray = {
  __typename?: 'TextAnswersConnectionTagsArray';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type TextAnswersConnectionTitle = {
  __typename?: 'TextAnswersConnectionTitle';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TextAnswersConnectionUid = {
  __typename?: 'TextAnswersConnectionUID';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TextAnswersConnectionUpdated_At = {
  __typename?: 'TextAnswersConnectionUpdated_at';
  connection?: Maybe<TextAnswersConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type TextAnswersGroupBy = {
  __typename?: 'TextAnswersGroupBy';
  Answer?: Maybe<Array<Maybe<TextAnswersConnectionAnswer>>>;
  PublishedAt?: Maybe<Array<Maybe<TextAnswersConnectionPublishedAt>>>;
  Slug?: Maybe<Array<Maybe<TextAnswersConnectionSlug>>>;
  Status?: Maybe<Array<Maybe<TextAnswersConnectionStatus>>>;
  TagsArray?: Maybe<Array<Maybe<TextAnswersConnectionTagsArray>>>;
  Title?: Maybe<Array<Maybe<TextAnswersConnectionTitle>>>;
  UID?: Maybe<Array<Maybe<TextAnswersConnectionUid>>>;
  created_at?: Maybe<Array<Maybe<TextAnswersConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TextAnswersConnectionId>>>;
  locale?: Maybe<Array<Maybe<TextAnswersConnectionLocale>>>;
  published_at?: Maybe<Array<Maybe<TextAnswersConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<TextAnswersConnectionUpdated_At>>>;
};

export type ThemeInput = {
  Companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UID: Scalars['String']['input'];
  additional_product_background_color?: InputMaybe<Scalars['String']['input']>;
  additional_product_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  additional_product_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  additional_product_font_color?: InputMaybe<Scalars['String']['input']>;
  company_title_color?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  homepage_picture?: InputMaybe<Enum_Themes_Homepage_Picture>;
  homepage_section_title_color?: InputMaybe<Scalars['String']['input']>;
  information_cta_color?: InputMaybe<Scalars['String']['input']>;
  modal_banner_background_color?: InputMaybe<Scalars['String']['input']>;
  modal_picture?: InputMaybe<Enum_Themes_Modal_Picture>;
  modal_picture_background_color?: InputMaybe<Scalars['String']['input']>;
  product_page_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  product_page_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  product_title_color?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  review_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  review_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  review_modal_cta_color?: InputMaybe<Scalars['String']['input']>;
  social_button_background_color?: InputMaybe<Scalars['String']['input']>;
  social_button_icon_color?: InputMaybe<Scalars['String']['input']>;
  story_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  story_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  story_title_font_color?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type Themes = {
  __typename?: 'Themes';
  Companies?: Maybe<Array<Maybe<Companies>>>;
  PublishedAt?: Maybe<Scalars['DateTime']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  UID: Scalars['String']['output'];
  additional_product_background_color?: Maybe<Scalars['String']['output']>;
  additional_product_cta_background_color?: Maybe<Scalars['String']['output']>;
  additional_product_cta_font_color?: Maybe<Scalars['String']['output']>;
  additional_product_font_color?: Maybe<Scalars['String']['output']>;
  company_title_color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  homepage_picture?: Maybe<Enum_Themes_Homepage_Picture>;
  homepage_section_title_color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  information_cta_color?: Maybe<Scalars['String']['output']>;
  modal_banner_background_color?: Maybe<Scalars['String']['output']>;
  modal_picture?: Maybe<Enum_Themes_Modal_Picture>;
  modal_picture_background_color?: Maybe<Scalars['String']['output']>;
  product_page_cta_background_color?: Maybe<Scalars['String']['output']>;
  product_page_cta_font_color?: Maybe<Scalars['String']['output']>;
  product_title_color?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  review_cta_background_color?: Maybe<Scalars['String']['output']>;
  review_cta_font_color?: Maybe<Scalars['String']['output']>;
  review_modal_cta_color?: Maybe<Scalars['String']['output']>;
  social_button_background_color?: Maybe<Scalars['String']['output']>;
  social_button_icon_color?: Maybe<Scalars['String']['output']>;
  story_cta_background_color?: Maybe<Scalars['String']['output']>;
  story_cta_font_color?: Maybe<Scalars['String']['output']>;
  story_title_font_color?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type ThemesCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type ThemesAggregator = {
  __typename?: 'ThemesAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ThemesConnection = {
  __typename?: 'ThemesConnection';
  aggregate?: Maybe<ThemesAggregator>;
  groupBy?: Maybe<ThemesGroupBy>;
  values?: Maybe<Array<Maybe<Themes>>>;
};

export type ThemesConnectionAdditional_Product_Background_Color = {
  __typename?: 'ThemesConnectionAdditional_product_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionAdditional_Product_Cta_Background_Color = {
  __typename?: 'ThemesConnectionAdditional_product_cta_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionAdditional_Product_Cta_Font_Color = {
  __typename?: 'ThemesConnectionAdditional_product_cta_font_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionAdditional_Product_Font_Color = {
  __typename?: 'ThemesConnectionAdditional_product_font_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionCompany_Title_Color = {
  __typename?: 'ThemesConnectionCompany_title_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionCreated_At = {
  __typename?: 'ThemesConnectionCreated_at';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ThemesConnectionHomepage_Picture = {
  __typename?: 'ThemesConnectionHomepage_picture';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionHomepage_Section_Title_Color = {
  __typename?: 'ThemesConnectionHomepage_section_title_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionId = {
  __typename?: 'ThemesConnectionId';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type ThemesConnectionInformation_Cta_Color = {
  __typename?: 'ThemesConnectionInformation_cta_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionModal_Banner_Background_Color = {
  __typename?: 'ThemesConnectionModal_banner_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionModal_Picture = {
  __typename?: 'ThemesConnectionModal_picture';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionModal_Picture_Background_Color = {
  __typename?: 'ThemesConnectionModal_picture_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionProduct_Page_Cta_Background_Color = {
  __typename?: 'ThemesConnectionProduct_page_cta_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionProduct_Page_Cta_Font_Color = {
  __typename?: 'ThemesConnectionProduct_page_cta_font_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionProduct_Title_Color = {
  __typename?: 'ThemesConnectionProduct_title_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionPublishedAt = {
  __typename?: 'ThemesConnectionPublishedAt';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ThemesConnectionPublished_At = {
  __typename?: 'ThemesConnectionPublished_at';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ThemesConnectionReview_Cta_Background_Color = {
  __typename?: 'ThemesConnectionReview_cta_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionReview_Cta_Font_Color = {
  __typename?: 'ThemesConnectionReview_cta_font_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionReview_Modal_Cta_Color = {
  __typename?: 'ThemesConnectionReview_modal_cta_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionSocial_Button_Background_Color = {
  __typename?: 'ThemesConnectionSocial_button_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionSocial_Button_Icon_Color = {
  __typename?: 'ThemesConnectionSocial_button_icon_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionStatus = {
  __typename?: 'ThemesConnectionStatus';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionStory_Cta_Background_Color = {
  __typename?: 'ThemesConnectionStory_cta_background_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionStory_Cta_Font_Color = {
  __typename?: 'ThemesConnectionStory_cta_font_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionStory_Title_Font_Color = {
  __typename?: 'ThemesConnectionStory_title_font_color';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionUid = {
  __typename?: 'ThemesConnectionUID';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ThemesConnectionUpdated_At = {
  __typename?: 'ThemesConnectionUpdated_at';
  connection?: Maybe<ThemesConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type ThemesGroupBy = {
  __typename?: 'ThemesGroupBy';
  PublishedAt?: Maybe<Array<Maybe<ThemesConnectionPublishedAt>>>;
  Status?: Maybe<Array<Maybe<ThemesConnectionStatus>>>;
  UID?: Maybe<Array<Maybe<ThemesConnectionUid>>>;
  additional_product_background_color?: Maybe<Array<Maybe<ThemesConnectionAdditional_Product_Background_Color>>>;
  additional_product_cta_background_color?: Maybe<Array<Maybe<ThemesConnectionAdditional_Product_Cta_Background_Color>>>;
  additional_product_cta_font_color?: Maybe<Array<Maybe<ThemesConnectionAdditional_Product_Cta_Font_Color>>>;
  additional_product_font_color?: Maybe<Array<Maybe<ThemesConnectionAdditional_Product_Font_Color>>>;
  company_title_color?: Maybe<Array<Maybe<ThemesConnectionCompany_Title_Color>>>;
  created_at?: Maybe<Array<Maybe<ThemesConnectionCreated_At>>>;
  homepage_picture?: Maybe<Array<Maybe<ThemesConnectionHomepage_Picture>>>;
  homepage_section_title_color?: Maybe<Array<Maybe<ThemesConnectionHomepage_Section_Title_Color>>>;
  id?: Maybe<Array<Maybe<ThemesConnectionId>>>;
  information_cta_color?: Maybe<Array<Maybe<ThemesConnectionInformation_Cta_Color>>>;
  modal_banner_background_color?: Maybe<Array<Maybe<ThemesConnectionModal_Banner_Background_Color>>>;
  modal_picture?: Maybe<Array<Maybe<ThemesConnectionModal_Picture>>>;
  modal_picture_background_color?: Maybe<Array<Maybe<ThemesConnectionModal_Picture_Background_Color>>>;
  product_page_cta_background_color?: Maybe<Array<Maybe<ThemesConnectionProduct_Page_Cta_Background_Color>>>;
  product_page_cta_font_color?: Maybe<Array<Maybe<ThemesConnectionProduct_Page_Cta_Font_Color>>>;
  product_title_color?: Maybe<Array<Maybe<ThemesConnectionProduct_Title_Color>>>;
  published_at?: Maybe<Array<Maybe<ThemesConnectionPublished_At>>>;
  review_cta_background_color?: Maybe<Array<Maybe<ThemesConnectionReview_Cta_Background_Color>>>;
  review_cta_font_color?: Maybe<Array<Maybe<ThemesConnectionReview_Cta_Font_Color>>>;
  review_modal_cta_color?: Maybe<Array<Maybe<ThemesConnectionReview_Modal_Cta_Color>>>;
  social_button_background_color?: Maybe<Array<Maybe<ThemesConnectionSocial_Button_Background_Color>>>;
  social_button_icon_color?: Maybe<Array<Maybe<ThemesConnectionSocial_Button_Icon_Color>>>;
  story_cta_background_color?: Maybe<Array<Maybe<ThemesConnectionStory_Cta_Background_Color>>>;
  story_cta_font_color?: Maybe<Array<Maybe<ThemesConnectionStory_Cta_Font_Color>>>;
  story_title_font_color?: Maybe<Array<Maybe<ThemesConnectionStory_Title_Font_Color>>>;
  updated_at?: Maybe<Array<Maybe<ThemesConnectionUpdated_At>>>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<Morph>>>;
  relations: Array<FileRelation>;
  size: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};


export type UploadFileRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  avg?: Maybe<UploadFileAggregatorAvg>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<UploadFileAggregatorMax>;
  min?: Maybe<UploadFileAggregatorMin>;
  sum?: Maybe<UploadFileAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  height?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  height?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  height?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  height?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  aggregate?: Maybe<UploadFileAggregator>;
  groupBy?: Maybe<UploadFileGroupBy>;
  values?: Maybe<Array<Maybe<UploadFile>>>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Float']['output']>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
};

export type UserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  controller: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  policy?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  type: Scalars['String']['output'];
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type UsersPermissionsRoleUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updated_at: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']['output']>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
};

export type VariantInput = {
  Availability?: InputMaybe<Scalars['String']['input']>;
  ExternalId?: InputMaybe<Scalars['String']['input']>;
  Gtin?: InputMaybe<Scalars['String']['input']>;
  ImageUrl?: InputMaybe<Scalars['String']['input']>;
  Images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Name: Scalars['String']['input'];
  Options?: InputMaybe<Array<VariantOptionInput>>;
  Price?: InputMaybe<PriceInput>;
  Product?: InputMaybe<Scalars['ID']['input']>;
  Source?: InputMaybe<Scalars['JSON']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type VariantOption = {
  __typename?: 'VariantOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VariantOptionInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Variants = {
  __typename?: 'Variants';
  Availability?: Maybe<Scalars['String']['output']>;
  ExternalId?: Maybe<Scalars['String']['output']>;
  Gtin?: Maybe<Scalars['String']['output']>;
  ImageUrl?: Maybe<Scalars['String']['output']>;
  Images?: Maybe<Array<Maybe<UploadFile>>>;
  Name: Scalars['String']['output'];
  Options?: Maybe<Array<VariantOption>>;
  Price?: Maybe<Price>;
  Product?: Maybe<AdditionalProducts>;
  Source?: Maybe<Scalars['JSON']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<Array<Maybe<Variants>>>;
  updated_at: Scalars['DateTime']['output'];
};


export type VariantsImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type VariantsLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type VariantsAggregator = {
  __typename?: 'VariantsAggregator';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VariantsConnection = {
  __typename?: 'VariantsConnection';
  aggregate?: Maybe<VariantsAggregator>;
  groupBy?: Maybe<VariantsGroupBy>;
  values?: Maybe<Array<Maybe<Variants>>>;
};

export type VariantsConnectionAvailability = {
  __typename?: 'VariantsConnectionAvailability';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsConnectionCreated_At = {
  __typename?: 'VariantsConnectionCreated_at';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type VariantsConnectionExternalId = {
  __typename?: 'VariantsConnectionExternalId';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsConnectionGtin = {
  __typename?: 'VariantsConnectionGtin';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsConnectionId = {
  __typename?: 'VariantsConnectionId';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type VariantsConnectionImageUrl = {
  __typename?: 'VariantsConnectionImageUrl';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsConnectionLocale = {
  __typename?: 'VariantsConnectionLocale';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsConnectionName = {
  __typename?: 'VariantsConnectionName';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsConnectionProduct = {
  __typename?: 'VariantsConnectionProduct';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type VariantsConnectionSource = {
  __typename?: 'VariantsConnectionSource';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['JSON']['output']>;
};

export type VariantsConnectionUpdated_At = {
  __typename?: 'VariantsConnectionUpdated_at';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['DateTime']['output']>;
};

export type VariantsConnectionUrl = {
  __typename?: 'VariantsConnectionUrl';
  connection?: Maybe<VariantsConnection>;
  key?: Maybe<Scalars['String']['output']>;
};

export type VariantsGroupBy = {
  __typename?: 'VariantsGroupBy';
  Availability?: Maybe<Array<Maybe<VariantsConnectionAvailability>>>;
  ExternalId?: Maybe<Array<Maybe<VariantsConnectionExternalId>>>;
  Gtin?: Maybe<Array<Maybe<VariantsConnectionGtin>>>;
  ImageUrl?: Maybe<Array<Maybe<VariantsConnectionImageUrl>>>;
  Name?: Maybe<Array<Maybe<VariantsConnectionName>>>;
  Product?: Maybe<Array<Maybe<VariantsConnectionProduct>>>;
  Source?: Maybe<Array<Maybe<VariantsConnectionSource>>>;
  Url?: Maybe<Array<Maybe<VariantsConnectionUrl>>>;
  created_at?: Maybe<Array<Maybe<VariantsConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<VariantsConnectionId>>>;
  locale?: Maybe<Array<Maybe<VariantsConnectionLocale>>>;
  updated_at?: Maybe<Array<Maybe<VariantsConnectionUpdated_At>>>;
};

export type CreateAdditionalProductInput = {
  data?: InputMaybe<AdditionalProductInput>;
};

export type CreateAdditionalProductPayload = {
  __typename?: 'createAdditionalProductPayload';
  additionalProduct?: Maybe<AdditionalProducts>;
};

export type CreateArticleInput = {
  data?: InputMaybe<ArticleInput>;
};

export type CreateArticlePayload = {
  __typename?: 'createArticlePayload';
  article?: Maybe<Articles>;
};

export type CreateCompanyInput = {
  data?: InputMaybe<CompanyInput>;
};

export type CreateCompanyPayload = {
  __typename?: 'createCompanyPayload';
  company?: Maybe<Companies>;
};

export type CreateFlowPageInput = {
  data?: InputMaybe<FlowPageInput>;
};

export type CreateFlowPagePayload = {
  __typename?: 'createFlowPagePayload';
  flowPage?: Maybe<FlowPages>;
};

export type CreateFormInput = {
  data?: InputMaybe<FormInput>;
};

export type CreateFormPageInput = {
  data?: InputMaybe<FormPageInput>;
};

export type CreateFormPagePayload = {
  __typename?: 'createFormPagePayload';
  formPage?: Maybe<FormPages>;
};

export type CreateFormPayload = {
  __typename?: 'createFormPayload';
  form?: Maybe<Forms>;
};

export type CreateModalInput = {
  data?: InputMaybe<ModalInput>;
};

export type CreateModalPayload = {
  __typename?: 'createModalPayload';
  modal?: Maybe<Modals>;
};

export type CreateModuleInput = {
  data?: InputMaybe<ModuleInput>;
};

export type CreateModulePayload = {
  __typename?: 'createModulePayload';
  module?: Maybe<Modules>;
};

export type CreateNodeInput = {
  data?: InputMaybe<NodeInput>;
};

export type CreateNodePayload = {
  __typename?: 'createNodePayload';
  node?: Maybe<Nodes>;
};

export type CreateProductInput = {
  data?: InputMaybe<ProductInput>;
};

export type CreateProductPayload = {
  __typename?: 'createProductPayload';
  product?: Maybe<Products>;
};

export type CreateRoleInput = {
  data?: InputMaybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateStoryInput = {
  data?: InputMaybe<StoryInput>;
};

export type CreateStoryPageInput = {
  data?: InputMaybe<StoryPageInput>;
};

export type CreateStoryPagePayload = {
  __typename?: 'createStoryPagePayload';
  storyPage?: Maybe<StoryPages>;
};

export type CreateStoryPayload = {
  __typename?: 'createStoryPayload';
  story?: Maybe<Stories>;
};

export type CreateTextAnswerInput = {
  data?: InputMaybe<TextAnswerInput>;
};

export type CreateTextAnswerPayload = {
  __typename?: 'createTextAnswerPayload';
  textAnswer?: Maybe<TextAnswers>;
};

export type CreateThemeInput = {
  data?: InputMaybe<ThemeInput>;
};

export type CreateThemePayload = {
  __typename?: 'createThemePayload';
  theme?: Maybe<Themes>;
};

export type CreateUserInput = {
  data?: InputMaybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateVariantInput = {
  data?: InputMaybe<VariantInput>;
};

export type CreateVariantPayload = {
  __typename?: 'createVariantPayload';
  variant?: Maybe<Variants>;
};

export type DeleteAdditionalProductInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteAdditionalProductPayload = {
  __typename?: 'deleteAdditionalProductPayload';
  additionalProduct?: Maybe<AdditionalProducts>;
};

export type DeleteArticleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteArticlePayload = {
  __typename?: 'deleteArticlePayload';
  article?: Maybe<Articles>;
};

export type DeleteCompanyInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteCompanyPayload = {
  __typename?: 'deleteCompanyPayload';
  company?: Maybe<Companies>;
};

export type DeleteFileInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteFlowPageInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFlowPagePayload = {
  __typename?: 'deleteFlowPagePayload';
  flowPage?: Maybe<FlowPages>;
};

export type DeleteFormInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFormPageInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFormPagePayload = {
  __typename?: 'deleteFormPagePayload';
  formPage?: Maybe<FormPages>;
};

export type DeleteFormPayload = {
  __typename?: 'deleteFormPayload';
  form?: Maybe<Forms>;
};

export type DeleteModalInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteModalPayload = {
  __typename?: 'deleteModalPayload';
  modal?: Maybe<Modals>;
};

export type DeleteModuleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteModulePayload = {
  __typename?: 'deleteModulePayload';
  module?: Maybe<Modules>;
};

export type DeleteNodeInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteNodePayload = {
  __typename?: 'deleteNodePayload';
  node?: Maybe<Nodes>;
};

export type DeleteProductInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteProductPayload = {
  __typename?: 'deleteProductPayload';
  product?: Maybe<Products>;
};

export type DeleteRoleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteStoryInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteStoryPageInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteStoryPagePayload = {
  __typename?: 'deleteStoryPagePayload';
  storyPage?: Maybe<StoryPages>;
};

export type DeleteStoryPayload = {
  __typename?: 'deleteStoryPayload';
  story?: Maybe<Stories>;
};

export type DeleteTextAnswerInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTextAnswerPayload = {
  __typename?: 'deleteTextAnswerPayload';
  textAnswer?: Maybe<TextAnswers>;
};

export type DeleteThemeInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteThemePayload = {
  __typename?: 'deleteThemePayload';
  theme?: Maybe<Themes>;
};

export type DeleteUserInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteVariantInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteVariantPayload = {
  __typename?: 'deleteVariantPayload';
  variant?: Maybe<Variants>;
};

export type EditAdditionalProductInput = {
  CallToAction?: InputMaybe<Array<Scalars['AdditionalProductsCallToActionDynamicZoneInput']['input']>>;
  CardType?: InputMaybe<Enum_Additionalproducts_Cardtype>;
  Category?: InputMaybe<Scalars['String']['input']>;
  Company?: InputMaybe<Scalars['ID']['input']>;
  DefaultVariant?: InputMaybe<Scalars['ID']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ExternalId?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  ImageUrl?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Price?: InputMaybe<Scalars['String']['input']>;
  PriceV2?: InputMaybe<PriceInput>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['JSON']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  Variants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditArticleInput = {
  Metadata?: InputMaybe<Scalars['JSON']['input']>;
  Nodes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  RawState?: InputMaybe<Scalars['JSON']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditCompanyInput = {
  AdditionalProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Auth0OrgId?: InputMaybe<Scalars['String']['input']>;
  BannerImage?: InputMaybe<Scalars['ID']['input']>;
  CompanyLogo?: InputMaybe<Scalars['ID']['input']>;
  Config?: InputMaybe<Scalars['JSON']['input']>;
  CrmId?: InputMaybe<Scalars['String']['input']>;
  CustomHead?: InputMaybe<Scalars['String']['input']>;
  CustomTheme?: InputMaybe<Scalars['JSON']['input']>;
  DefaultLocale?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  EmbedCustomHead?: InputMaybe<Scalars['String']['input']>;
  FormPages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Forms?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Locales?: InputMaybe<Scalars['JSON']['input']>;
  Logo?: InputMaybe<Scalars['ID']['input']>;
  MediaLibrary?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Modals?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Name?: InputMaybe<Scalars['String']['input']>;
  PrimaryColor?: InputMaybe<Scalars['String']['input']>;
  PrivacyPolicy?: InputMaybe<Scalars['ID']['input']>;
  ProductCollection?: InputMaybe<Array<Scalars['CompaniesProductCollectionDynamicZoneInput']['input']>>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  SecondaryColor?: InputMaybe<Scalars['String']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  SocialLinks?: InputMaybe<Array<InputMaybe<EditComponentLinksSocialLinkInput>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Theme?: InputMaybe<Scalars['ID']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentAiChatInput = {
  AgentID?: InputMaybe<Scalars['Int']['input']>;
  Avatar?: InputMaybe<Scalars['ID']['input']>;
  InitialMessage?: InputMaybe<Scalars['String']['input']>;
  Suggestions?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentConsentsEmailInput = {
  CustomText?: InputMaybe<Scalars['String']['input']>;
  ImplicitConsent?: InputMaybe<Scalars['Boolean']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  PrivacyPolicyURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentContentAdditionalProductInput = {
  Additional_product?: InputMaybe<Scalars['ID']['input']>;
  Selected_variant?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentContentArticleInput = {
  Article?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentContentStoryInput = {
  Story?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentCtaEventCallToActionInput = {
  Text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentCtaLinkCallToActionInput = {
  Redirection_Type?: InputMaybe<RedirectionType>;
  Text?: InputMaybe<Scalars['String']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentCtaLockedContentCallToActionInput = {
  RegistrationModule?: InputMaybe<Scalars['ID']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentDisplayRichTextInput = {
  RichText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentElementsLoaderInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Duration?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormFieldsDateInputInput = {
  DefaultValue?: InputMaybe<Scalars['Date']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormFieldsFileInputInput = {
  AcceptedFileTypes?: InputMaybe<Scalars['JSON']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormFieldsInputInput = {
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Placeholder?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Enum_Componentformfieldsinput_Type>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormFieldsSingleSelectInput = {
  DisplayType?: InputMaybe<SingleSelectDisplayType>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Placeholder?: InputMaybe<Scalars['String']['input']>;
  Values?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormPagesFormPageInput = {
  FormPage?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormTemplatesNewsletterInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  EmailConsent?: InputMaybe<EditComponentConsentsEmailInput>;
  IsNameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormTemplatesRegistrationInput = {
  CtaText?: InputMaybe<Scalars['String']['input']>;
  EmailConsent?: InputMaybe<EditComponentConsentsEmailInput>;
  Identifier?: InputMaybe<Enum_Componentformtemplatesregistration_Identifier>;
  IsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  WithCGU?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormTemplatesReviewInput = {
  HasComment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentFormsFormInput = {
  Form?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentLinksProductLinkInput = {
  LinksTo?: InputMaybe<Enum_Componentlinksproductlinks_Linksto>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentLinksSocialLinkInput = {
  LinksTo?: InputMaybe<Enum_Componentlinkssociallinks_Linksto>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentPagesFlowPageInput = {
  FlowPage?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentUtilsModuleInput = {
  Module?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentUtilsProductCategoryInput = {
  IsCollapsible?: InputMaybe<Scalars['Boolean']['input']>;
  Products?: InputMaybe<Array<InputMaybe<EditComponentUtilsSimpleProductInput>>>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentUtilsSimpleProductInput = {
  Product?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  related?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Float']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type EditFlowPageInput = {
  AdditionalProduct?: InputMaybe<EditComponentContentAdditionalProductInput>;
  AllowExit?: InputMaybe<Scalars['Boolean']['input']>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Display?: InputMaybe<Enum_Flowpages_Display>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Loader?: InputMaybe<EditComponentElementsLoaderInput>;
  Product?: InputMaybe<Scalars['ID']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Registration?: InputMaybe<EditComponentFormsFormInput>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditFormInput = {
  Company?: InputMaybe<Scalars['ID']['input']>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  Elements?: InputMaybe<Array<Scalars['FormsElementsDynamicZoneInput']['input']>>;
  IsProductRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Enum_Forms_Type>;
  UID?: InputMaybe<Scalars['String']['input']>;
  WithCGU?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditFormPageInput = {
  Company?: InputMaybe<Scalars['ID']['input']>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  Elements: Array<Scalars['FormPagesElementsDynamicZoneInput']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  WithCGU?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditLocaleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditModalInput = {
  Company?: InputMaybe<Scalars['ID']['input']>;
  Elements?: InputMaybe<Array<Scalars['ModalsElementsDynamicZoneInput']['input']>>;
  Filter?: InputMaybe<Scalars['JSON']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Trigger?: InputMaybe<Enum_Modals_Trigger>;
  Type?: InputMaybe<Enum_Modals_Type>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditModuleInput = {
  Content?: InputMaybe<Array<Scalars['ModulesContentDynamicZoneInput']['input']>>;
  CtaText?: InputMaybe<Scalars['String']['input']>;
  DisplayType?: InputMaybe<ModuleDisplayType>;
  Icon?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  IsLocked?: InputMaybe<Scalars['Boolean']['input']>;
  Product?: InputMaybe<Scalars['ID']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Subtitle?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Enum_Modules_Type>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditNodeInput = {
  Article?: InputMaybe<Scalars['ID']['input']>;
  Children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Media?: InputMaybe<Scalars['ID']['input']>;
  NodeID?: InputMaybe<Scalars['String']['input']>;
  Order?: InputMaybe<Scalars['Int']['input']>;
  Parent?: InputMaybe<Scalars['ID']['input']>;
  Properties?: InputMaybe<Scalars['JSON']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Enum_Nodes_Type>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditProductInput = {
  Articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Characteristics?: InputMaybe<Scalars['JSON']['input']>;
  Company?: InputMaybe<Scalars['ID']['input']>;
  CrmId?: InputMaybe<Scalars['String']['input']>;
  FlowPages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Image?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ModuleList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Modules?: InputMaybe<Array<InputMaybe<EditComponentUtilsModuleInput>>>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Onboarding?: InputMaybe<Scalars['ID']['input']>;
  ProductDisplayType?: InputMaybe<Enum_Products_Productdisplaytype>;
  ProductLinks?: InputMaybe<Array<InputMaybe<EditComponentLinksProductLinkInput>>>;
  ProductLogo?: InputMaybe<Scalars['ID']['input']>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Stories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Subtitle?: InputMaybe<Scalars['String']['input']>;
  Text_answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditRoleInput = {
  created_by?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type EditStoryInput = {
  Config?: InputMaybe<Scalars['JSON']['input']>;
  PreviewImage?: InputMaybe<Scalars['ID']['input']>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  StoryPages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Tags?: InputMaybe<Scalars['JSON']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditStoryPageInput = {
  CallToAction?: InputMaybe<Array<Scalars['StoryPagesCallToActionDynamicZoneInput']['input']>>;
  DisplayText?: InputMaybe<Scalars['String']['input']>;
  Looping?: InputMaybe<Scalars['Boolean']['input']>;
  Media?: InputMaybe<Scalars['ID']['input']>;
  Order?: InputMaybe<Scalars['Int']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Story?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditTextAnswerInput = {
  Answer?: InputMaybe<Scalars['String']['input']>;
  Products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Tags?: InputMaybe<Scalars['String']['input']>;
  TagsArray?: InputMaybe<Scalars['JSON']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditThemeInput = {
  Companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  PublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  additional_product_background_color?: InputMaybe<Scalars['String']['input']>;
  additional_product_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  additional_product_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  additional_product_font_color?: InputMaybe<Scalars['String']['input']>;
  company_title_color?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  homepage_picture?: InputMaybe<Enum_Themes_Homepage_Picture>;
  homepage_section_title_color?: InputMaybe<Scalars['String']['input']>;
  information_cta_color?: InputMaybe<Scalars['String']['input']>;
  modal_banner_background_color?: InputMaybe<Scalars['String']['input']>;
  modal_picture?: InputMaybe<Enum_Themes_Modal_Picture>;
  modal_picture_background_color?: InputMaybe<Scalars['String']['input']>;
  product_page_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  product_page_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  product_title_color?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  review_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  review_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  review_modal_cta_color?: InputMaybe<Scalars['String']['input']>;
  social_button_background_color?: InputMaybe<Scalars['String']['input']>;
  social_button_icon_color?: InputMaybe<Scalars['String']['input']>;
  story_cta_background_color?: InputMaybe<Scalars['String']['input']>;
  story_cta_font_color?: InputMaybe<Scalars['String']['input']>;
  story_title_font_color?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type EditUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type EditVariantInput = {
  Availability?: InputMaybe<Scalars['String']['input']>;
  ExternalId?: InputMaybe<Scalars['String']['input']>;
  Gtin?: InputMaybe<Scalars['String']['input']>;
  ImageUrl?: InputMaybe<Scalars['String']['input']>;
  Images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Options?: InputMaybe<Array<VariantOptionInput>>;
  Price?: InputMaybe<PriceInput>;
  Product?: InputMaybe<Scalars['ID']['input']>;
  Source?: InputMaybe<Scalars['JSON']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAdditionalProductInput = {
  data?: InputMaybe<EditAdditionalProductInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateAdditionalProductPayload = {
  __typename?: 'updateAdditionalProductPayload';
  additionalProduct?: Maybe<AdditionalProducts>;
};

export type UpdateArticleInput = {
  data?: InputMaybe<EditArticleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateArticlePayload = {
  __typename?: 'updateArticlePayload';
  article?: Maybe<Articles>;
};

export type UpdateCompanyInput = {
  data?: InputMaybe<EditCompanyInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateCompanyPayload = {
  __typename?: 'updateCompanyPayload';
  company?: Maybe<Companies>;
};

export type UpdateFlowPageInput = {
  data?: InputMaybe<EditFlowPageInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateFlowPagePayload = {
  __typename?: 'updateFlowPagePayload';
  flowPage?: Maybe<FlowPages>;
};

export type UpdateFormInput = {
  data?: InputMaybe<EditFormInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateFormPageInput = {
  data?: InputMaybe<EditFormPageInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateFormPagePayload = {
  __typename?: 'updateFormPagePayload';
  formPage?: Maybe<FormPages>;
};

export type UpdateFormPayload = {
  __typename?: 'updateFormPayload';
  form?: Maybe<Forms>;
};

export type UpdateModalInput = {
  data?: InputMaybe<EditModalInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateModalPayload = {
  __typename?: 'updateModalPayload';
  modal?: Maybe<Modals>;
};

export type UpdateModuleInput = {
  data?: InputMaybe<EditModuleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateModulePayload = {
  __typename?: 'updateModulePayload';
  module?: Maybe<Modules>;
};

export type UpdateNodeInput = {
  data?: InputMaybe<EditNodeInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateNodePayload = {
  __typename?: 'updateNodePayload';
  node?: Maybe<Nodes>;
};

export type UpdateProductInput = {
  data?: InputMaybe<EditProductInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateProductPayload = {
  __typename?: 'updateProductPayload';
  product?: Maybe<Products>;
};

export type UpdateRoleInput = {
  data?: InputMaybe<EditRoleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateStoryInput = {
  data?: InputMaybe<EditStoryInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateStoryPageInput = {
  data?: InputMaybe<EditStoryPageInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateStoryPagePayload = {
  __typename?: 'updateStoryPagePayload';
  storyPage?: Maybe<StoryPages>;
};

export type UpdateStoryPayload = {
  __typename?: 'updateStoryPayload';
  story?: Maybe<Stories>;
};

export type UpdateTextAnswerInput = {
  data?: InputMaybe<EditTextAnswerInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTextAnswerPayload = {
  __typename?: 'updateTextAnswerPayload';
  textAnswer?: Maybe<TextAnswers>;
};

export type UpdateThemeInput = {
  data?: InputMaybe<EditThemeInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateThemePayload = {
  __typename?: 'updateThemePayload';
  theme?: Maybe<Themes>;
};

export type UpdateUserInput = {
  data?: InputMaybe<EditUserInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateVariantInput = {
  data?: InputMaybe<EditVariantInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateVariantPayload = {
  __typename?: 'updateVariantPayload';
  variant?: Maybe<Variants>;
};

export type UpdateVariantsInput = {
  data: EditVariantInput;
  filterString: Scalars['String']['input'];
};

export type UpdateVariantsPayload = {
  __typename?: 'updateVariantsPayload';
  variants?: Maybe<Array<Maybe<Variants>>>;
};

export type AdditionalProductFragment = { __typename?: 'AdditionalProducts', id: string, ImageUrl?: string | null, Name: string, Status?: string | null, Image?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null };

export type AdditionalProductComponentFragment = { __typename?: 'ComponentContentAdditionalProduct', Additional_product?: { __typename?: 'AdditionalProducts', id: string, ImageUrl?: string | null, Name: string, Status?: string | null, Image?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null } | null, Selected_variant?: { __typename?: 'Variants', id: string, ImageUrl?: string | null, Name: string, Images?: Array<{ __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null> | null } | null };

export type FileFragment = { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null };

export type StoryModuleFragment = { __typename?: 'Modules', id: string, Status?: string | null, Type: Enum_Modules_Type, Title: string, Content?: Array<{ __typename?: 'ComponentAiChat' } | { __typename?: 'ComponentContentAdditionalProduct' } | { __typename?: 'ComponentContentArticle' } | { __typename?: 'ComponentContentStory', Story?: { __typename?: 'Stories', id: string, Status?: string | null } | null } | { __typename?: 'ComponentCtaEventCallToAction' } | { __typename?: 'ComponentCtaLinkCallToAction' } | { __typename?: 'ComponentFormsForm' } | { __typename?: 'ComponentPagesFlowPage' } | null> | null, Product?: { __typename?: 'Products', Slug?: string | null, Company?: { __typename?: 'Companies', Slug?: string | null } | null } | null };

export type StoryFragment = { __typename?: 'Stories', id: string, Status?: string | null, Title: string, Slug?: string | null, locale?: string | null, PreviewImage?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null, StoryPages?: Array<{ __typename?: 'StoryPages', Media?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null, CallToAction?: Array<{ __typename?: 'ComponentContentAdditionalProduct', Additional_product?: { __typename?: 'AdditionalProducts', id: string, ImageUrl?: string | null, Name: string, Status?: string | null, Image?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null } | null, Selected_variant?: { __typename?: 'Variants', id: string, ImageUrl?: string | null, Name: string, Images?: Array<{ __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null> | null } | null } | { __typename?: 'ComponentCtaEventCallToAction' } | { __typename?: 'ComponentCtaLinkCallToAction' } | null> | null } | null> | null, Products?: Array<{ __typename?: 'Products', Slug?: string | null, Company?: { __typename?: 'Companies', Slug?: string | null } | null } | null> | null };

export type StoryComponentFragment = { __typename?: 'ComponentContentStory', Story?: { __typename?: 'Stories', id: string, Status?: string | null } | null };

export type VariantFragment = { __typename?: 'Variants', id: string, ImageUrl?: string | null, Name: string, Images?: Array<{ __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null> | null };

export type GetCompanyCustomHeadQueryVariables = Exact<{
  companySlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompanyCustomHeadQuery = { __typename?: 'Query', companies?: Array<{ __typename?: 'Companies', id: string, Status?: string | null, EmbedCustomHead?: string | null } | null> | null };

export type GetStoryModuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStoryModuleQuery = { __typename?: 'Query', module?: { __typename?: 'Modules', id: string, Status?: string | null, Type: Enum_Modules_Type, Title: string, Content?: Array<{ __typename?: 'ComponentAiChat' } | { __typename?: 'ComponentContentAdditionalProduct' } | { __typename?: 'ComponentContentArticle' } | { __typename?: 'ComponentContentStory', Story?: { __typename?: 'Stories', id: string, Status?: string | null } | null } | { __typename?: 'ComponentCtaEventCallToAction' } | { __typename?: 'ComponentCtaLinkCallToAction' } | { __typename?: 'ComponentFormsForm' } | { __typename?: 'ComponentPagesFlowPage' } | null> | null, Product?: { __typename?: 'Products', Slug?: string | null, Company?: { __typename?: 'Companies', Slug?: string | null } | null } | null } | null };

export type GetStoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withStoryPage: Scalars['Boolean']['input'];
}>;


export type GetStoryQuery = { __typename?: 'Query', story?: { __typename?: 'Stories', id: string, Status?: string | null, Title: string, Slug?: string | null, locale?: string | null, PreviewImage?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null, StoryPages?: Array<{ __typename?: 'StoryPages', Media?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null, CallToAction?: Array<{ __typename?: 'ComponentContentAdditionalProduct', Additional_product?: { __typename?: 'AdditionalProducts', id: string, ImageUrl?: string | null, Name: string, Status?: string | null, Image?: { __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null } | null, Selected_variant?: { __typename?: 'Variants', id: string, ImageUrl?: string | null, Name: string, Images?: Array<{ __typename?: 'UploadFile', alternativeText?: string | null, ext?: string | null, hash: string, mime: string, url: string, formats?: any | null } | null> | null } | null } | { __typename?: 'ComponentCtaEventCallToAction' } | { __typename?: 'ComponentCtaLinkCallToAction' } | null> | null } | null> | null, Products?: Array<{ __typename?: 'Products', Slug?: string | null, Company?: { __typename?: 'Companies', Slug?: string | null } | null } | null> | null } | null };

export const StoryComponentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoryComponent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentStory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]} as unknown as DocumentNode<StoryComponentFragment, unknown>;
export const StoryModuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoryModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Modules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoryComponent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}},{"kind":"Field","name":{"kind":"Name","value":"Company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoryComponent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentStory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]} as unknown as DocumentNode<StoryModuleFragment, unknown>;
export const FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"ext"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"formats"}}]}}]} as unknown as DocumentNode<FileFragment, unknown>;
export const AdditionalProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdditionalProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"ext"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"formats"}}]}}]} as unknown as DocumentNode<AdditionalProductFragment, unknown>;
export const VariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Variant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"ext"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"formats"}}]}}]} as unknown as DocumentNode<VariantFragment, unknown>;
export const AdditionalProductComponentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProductComponent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentAdditionalProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Additional_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalProduct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Selected_variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Variant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"ext"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"formats"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdditionalProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Variant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]} as unknown as DocumentNode<AdditionalProductComponentFragment, unknown>;
export const StoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Story"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Slug"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"PreviewImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"StoryPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"Order:asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withStoryPage"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CallToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalProductComponent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}},{"kind":"Field","name":{"kind":"Name","value":"Company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"ext"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"formats"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdditionalProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Variant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProductComponent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentAdditionalProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Additional_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalProduct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Selected_variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Variant"}}]}}]}}]} as unknown as DocumentNode<StoryFragment, unknown>;
export const GetCompanyCustomHeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyCustomHead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companySlug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"StringValue","value":"all","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companySlug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"EmbedCustomHead"}}]}}]}}]} as unknown as DocumentNode<GetCompanyCustomHeadQuery, GetCompanyCustomHeadQueryVariables>;
export const GetStoryModuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoryModule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoryModule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoryComponent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentStory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Story"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoryModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Modules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoryComponent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}},{"kind":"Field","name":{"kind":"Name","value":"Company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetStoryModuleQuery, GetStoryModuleQueryVariables>;
export const GetStoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withStoryPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"story"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Story"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"ext"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"formats"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdditionalProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Variant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalProductComponent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentContentAdditionalProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Additional_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalProduct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Selected_variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Variant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Story"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Slug"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"PreviewImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"StoryPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"Order:asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withStoryPage"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CallToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalProductComponent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}},{"kind":"Field","name":{"kind":"Name","value":"Company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetStoryQuery, GetStoryQueryVariables>;